/* eslint-disable no-prototype-builtins */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { TopicTypes } from "../../../utils/constants";
import * as BABYLON from "@babylonjs/core";
import { Inspector } from "@babylonjs/inspector";
import axios, { all } from "axios";
import qs from "querystring";
import { RenderHelper as RH } from "./renderHelpers.js";
import { TemplateSets } from "@/utils/pattern-assets";
import pattern from "@/pages/topic-details/pattern";
import { Mesh } from "@babylonjs/core";
import { Save } from "@mui/icons-material";

/** @type {BABYLON.Scene} */
let scene;
/** @type {BABYLON.Engine} */
let engine;
/** @type {BABYLON.ArcRotateCamera} */
let camera;
let currentItem = null;

let patternProps = {
  currentTemplate: null,
  currentAccentID: null,
  currentFrameID: null,
  // currentPatternFrameID: null,
  currentAccentScale: null,
  currentAccentNumber: null,
  currentAccentRotation: null,
  currentSceneID: null,
  // boarderWidth: 0,
  // boarderType: 'square',
  mattingWidth: 0,
  currentPrintTiling: 1,
};

let isTemplateLoading = false;
let isAccentLoading = false;
let isFrameLoading = false;
let isRestoring = false;

let previousAccentParents = [];
let individualAccentScale = 1;
let accentParentOffsets = new Map();
let frameOriginalMaterial = null;
let framePartMeshes = [];
let isFirstScreenshotTaken = false;
let firstApplyPatternDone = false;

let minCameraHorizontalBounds = 0;
let maxCameraHorizontalBounds = 0;
let clippingPlanes = [];

/** @type {BABYLON.FreeCamera} */
let onEdit;
let onPatternRestore;
let historyIndex = 0;
let onAssetsUpdate;
let toggleSliderVisibility;
let updateSliderFromAccentScale;
let updateSliderFromAccentNumber;
let updateSliderFromAccentRotation;
let updateSliderFromPrintTiling;
let updateSliderFromCameraHorizontalPosition;
let sharedMaterial = null;
let sharedFrom = null;
let downPoint = new BABYLON.Vector2(0, 0);
let upPoint = new BABYLON.Vector2(0, 0);
let downTime = 0;
let didCanvasDown = false;
let isCtrlPointer = false;
let previousPickedMesh = null;
let mergeMode = false;
let mode = "edit"; // edit or preview
let setMode;
/** @type {Set<BABYLON.Mesh>} */
const meshesSelectedForMerging = new Set();
/** @type {Array<BABYLON.HighlightLayer>} */

let currentMerges = {};
let outlineNeedsUpdate = false;
let sourceMesh = null;
let startX, startZ;
let initialAccentUVs = [];

let topicType = null; // pattern, gallery, wallart
let grabbable = false;
let shadowGenerator = null;

let transparentMaterial = null;
let applyPatternFinished = false;

let templateMeshesCache = [];
let isSceneDirty = false;

const patternFrameNames = [
  { name: "Frame_Back", description: "back" },
  { name: "Frame_CornerBL", description: "corner bottom left" },
  { name: "Frame_CornerBR", description: "corner bottom right" },
  { name: "Frame_CornerTL", description: "corner top left" },
  { name: "Frame_CornerTR", description: "corner top right" },
  { name: "Frame_SideB", description: "bottom" },
  { name: "Frame_SideL", description: "left" },
  { name: "Frame_SideR", description: "right" },
  { name: "Frame_SideT", description: "top" },
];

let frameOriginalPositions = [];

let frameOriginalScale = new BABYLON.Vector3(1, 1, 1);

// Store original dimensions for gallery frames (per template)
let galleryFrameOriginalDimensions = new Map();

let originalCanvasStyles = {};
let minPrintTile = 1,
  maxPrintTile = 8;

const MaterialMapping = [
  {
    tagName: "PatternOverlayID",
    test: /^template_/,
    prefix: "template",
  },
  {
    tagName: "PatternOverlayAccentID",
    test: /^accent_/,
    prefix: "accent",
  },
  {
    tagName: "PatternOverlaySceneID",
    test: /^scene_/,
    prefix: "scene",
  },
  // {
  //   tagName: 'PatternOverlayBoarderID',
  //   test: /^boarder_/,
  //   prefix: 'boarder',
  // },
  {
    tagName: "PatternOverlayFrameID",
    test: /^frame/,
    prefix: "frame",
  },
];
const STATIC_ASSETS_DIRECTORY = "/assets/patterns/";
// const OVERLAY_TEST_REGEX = /overlay/i

const patternHistory = [];
let Assets;
let Uploads = [];
let fpsElem;

export const addUploadAssets = (data) => {
  Uploads = Uploads.concat(data);
};

export const APPLICATION_MODES = {
  NONE: 0,
  APPLY_PRINT: 1,
  APPLY_PATTERN: 2,
  APPLY_MATERIAL: 3,
  APPLY_COLOR: 4,
  MERGE_SURFACES: 5,
  SPLIT_SURFACES: 6,
  ROTATE_TILE: 7,
  PICKER_PICKING: 8,
  PICKER_PICKED: 9,
  APPLY_ACCENT: 10,
  FULL_SCREEN: 11,
  HIDE_SURFACES: 12,
};

export let APPLYTOALL_ACTIVE = false;
export const setApplyToAllActive = (value) => {
  APPLYTOALL_ACTIVE = value;
};
export const getTopicType = () => topicType;
export const getApplyToAllActive = () => APPLYTOALL_ACTIVE;

const pScale = [0, 0.585, 0.585, 0.585, Math.sqrt(0.4)];
const mScale = [0, 0.85, 1, 1, 1];

let applicationMode = APPLICATION_MODES.NONE;
let currentCategory = "";
export const getApplicationMode = () => currentCategory;

export function SetCurrentCategory(category) {
  currentCategory = category;
}

export function GetSceneObject() {
  return scene;
}

//FOR DEBUG FPS, REMOVE LATER
export function GetEngineObject() {
  return engine;
}

export function ResetRenderer() {
  patternHistory.length = 0;
  meshesSelectedForMerging.clear();
  historyIndex = 0;
  patternProps.currentTemplate = null;
  patternProps.currentAccentID = null;
  patternProps.currentAccentScale = null;
  patternProps.currentAccentNumber = null;
  patternProps.currentAccentRotation = null;
  patternProps.currentFrameID = null;
  // patternProps.currentPatternFrameID = null
  patternProps.currentSceneID = null;
  // patternProps.boarderWidth = 0
  // patternProps.boarderType = 'square'
  patternProps.mattingWidth = 0;
  patternProps.currentPrintTiling = 1;
  sharedMaterial = null;
  outlineNeedsUpdate = false;
  sharedFrom = null;
  currentMerges = {};
  // RH.SafelyDisposeMaterials()
}

// `accentID` lets a template switch re-apply the accent the user already
// had selected instead of always dropping it — templates are per-scene, so
// swapping scenes shouldn't silently clear an unrelated accent choice.
export function ResetTemplate(accentID = null) {
  if (patternProps.currentTemplate != null) {
    let currentId = patternProps.currentTemplate.id;
    patternProps.currentTemplate = null;
    patternProps.currentAccentID = accentID;
    patternProps.currentAccentScale = 1;
    patternProps.currentAccentNumber = 1;
    patternProps.currentAccentRotation = 0.001;
    patternProps.currentFrameID = null;
    // patternProps.currentPatternFrameID = null
    patternProps.currentSceneID = null;

    patternProps.currentPrintTiling = 1;
    framePartMeshes = [];
    patternProps.mattingWidth = 0;

    RH.ClearScene(["scene"]);

    getTemplate(currentId)
      .then(applyTemplate)
      .then((result) => {
        savePattern(true, () => {
          // reset boarder after changing template for gallery only

          // applyBoarders()
          applyMattings();
        });
        createClippingMask();
        RH.SafelyDisposeMaterials();
        if (accentID) {
          applySingleAccent(accentID);
        }
      });
  }
}

/**
 * @param {any} initObject
 */
export function StartRenderer(initObject) {
  ResetRenderer();

  // initObject.canvas.style.position = 'absolute';
  // initObject.canvas.style.bottom = '70px';
  // initObject.canvas.style.height = '100%';
  // initObject.canvas.style.position = 'absolute';
  // initObject.canvas.style.top = '69px';
  // initObject.canvas.style.height = `calc(100vh - 69px - 69px)`;

  // console.log('Render main : ', initObject, ' canvas : ', initObject.canvas)

  if (Object.keys(originalCanvasStyles).length === 0) {
    originalCanvasStyles = {
      position: initObject.canvas.style.position,
      top: initObject.canvas.style.top,
      height: initObject.canvas.style.height,
    };
  }

  engine = new BABYLON.Engine(initObject.canvas, true, {
    preserveDrawingBuffer: true,
    stencil: true,
  });
  grabbable = initObject.canGrab;
  createScene();
  onWindowResize(initObject.canvas);
  // createLights()
  createCamera();
  setMode = initObject.setMode;
  mode = initObject.mode;
  RH.Initialize({
    scene: scene,
    engine: engine,
    addNote: initObject.addNote,
  });
  RH.CreateTextPlane();
  Assets = initObject.assets;

  // Assets.colors.push({
  //   name: 'AddColor',
  //   hex: [],
  // })

  setBindings(initObject.canvas);
  onEdit = initObject.onEdit;
  onPatternRestore = initObject.onPatternRestore;
  onAssetsUpdate = initObject.onAssetsUpdate;
  toggleSliderVisibility = initObject.toggleSliderVisibility;
  updateSliderFromAccentScale = initObject.updateSliderFromAccentScale;
  updateSliderFromAccentNumber = initObject.updateSliderFromAccentNumber;
  updateSliderFromAccentRotation = initObject.updateSliderFromAccentRotation;
  updateSliderFromPrintTiling = initObject.updateSliderFromPrintTiling;
  updateSliderFromCameraHorizontalPosition =
    initObject.updateSliderFromCameraHorizontalPosition;
  // createFPSElem(initObject.canvas)
}

function createFPSElem(_canvas) {
  fpsElem = document.createElement("div");
  fpsElem.style.position = "absolute";
  fpsElem.style.top = "15px";
  fpsElem.style.left = "15px";
  fpsElem.style.fontSize = "2em";
  fpsElem.style.textShadow = "1px -1px black";
  // _canvas.parentElement.appendChild(fpsElem)
}

// set canvas mode (edit or preview)
export function SetCanvasMode(value) {
  const canvas = engine.getRenderingCanvas();
  // mode = value === 'preview' ? 'preview' : 'edit'
  mode = value; //=== 'preview' ? 'preview' : 'edit'
  // console.log('====CURRENT MODE : ', mode)
  //
  // if (mode === 'fullScreen') {
  //   canvas.style.position = 'absolute'
  //   canvas.style.top = '0px'
  //   canvas.style.height = '100%'
  //   scene.meshes.forEach((mesh) => {
  //     if (mesh.getBehaviorByName('PointerDrag')) {
  //       mesh._behaviors[0].enabled = true
  //     }
  //   })
  //   console.log('SHOULD HAVE SHOW THE FULLSCREEN SETTING, WITH ZERO TOP')
  //   return
  // }

  if (mode === "preview") {
    // Object.assign(canvas.style, originalCanvasStyles);
    canvas.style.position = "absolute";
    // canvas.style.top = '69px'
    // canvas.style.height = `calc(100vh - 69px - 69px)`
    canvas.style.top = "0px";
    canvas.style.height = "100%";
    // scene.meshes.forEach((mesh) => {
    //   if (mesh.getBehaviorByName('PointerDrag')) {
    //     mesh._behaviors[0].enabled = false
    //   }
    // })
  } else if (mode === "edit") {
    canvas.style.position = "absolute";
    canvas.style.top = "69px";
    canvas.style.height = `calc(100vh - 69px - 69px)`;
  }
}

export function SetCanvasArea(value) {
  const canvas = engine.getRenderingCanvas();
  // canvas.style.position = 'absolute';
  // canvas.style.top = '69px';
  Object.assign(canvas.style, originalCanvasStyles);
  // canvas.style.height = `calc(100vh - 69px - 69px)`;
  // console.log('Set canvas area')
}

export function ResizeBabylonScene() {
  onWindowResize(scene._engine._renderingCanvas);
  SetCanvasArea();
}

export function SetFullScreen(isFullscreen) {
  console.log("Is Fullscreen : ", isFullscreen);
}

export function CameraZoomInPressed() {
  camera.radius = Math.max(camera.radius - 0.5, camera.lowerRadiusLimit);
}

export function CameraZoomOutPressed() {
  camera.radius = Math.min(camera.radius + 0.5, camera.upperRadiusLimit);
}

export function SetCameraHorizontalPosition(value) {
  // const targetX = 2 * value - 1;
  const targetX =
    minCameraHorizontalBounds +
    (maxCameraHorizontalBounds - minCameraHorizontalBounds) * value;
  const currentAlpha = camera.alpha;
  const currentBeta = camera.beta;
  const currentRadius = camera.radius;
  const currentTarget = camera.target;

  camera.setTarget(
    new BABYLON.Vector3(targetX, currentTarget.y, currentTarget.z),
  );

  camera.alpha = currentAlpha;
  camera.beta = currentBeta;
  camera.radius = currentRadius;
}

export function SetTopicType(type) {
  topicType = TopicTypes[type].key;
  RH.SetTopicType(topicType);
  setApplyToAllActive(false);
}

export function SetAccentRotation(value) {
  if (!previousAccentParents || previousAccentParents.length === 0) return;

  const rotationInRadians = BABYLON.Tools.ToRadians(value);

  let tempPivot = scene.getTransformNodeByName("accent_temp_pivot");

  if (!tempPivot) {
    const templates = templateMeshesCache;
    let centerX = 0,
      centerZ = 0;

    if (templates && templates.length > 0) {
      let min = new BABYLON.Vector3(
        Number.POSITIVE_INFINITY,
        0,
        Number.POSITIVE_INFINITY,
      );
      let max = new BABYLON.Vector3(
        Number.NEGATIVE_INFINITY,
        0,
        Number.NEGATIVE_INFINITY,
      );

      templates.forEach((template) => {
        const boundingBox = template.getBoundingInfo().boundingBox;
        min = BABYLON.Vector3.Minimize(min, boundingBox.minimumWorld);
        max = BABYLON.Vector3.Maximize(max, boundingBox.maximumWorld);
      });

      centerX = (min.x + max.x) / 2;
      centerZ = (min.z + max.z) / 2;
    }

    tempPivot = new BABYLON.TransformNode("accent_temp_pivot", scene);
    tempPivot.position = new BABYLON.Vector3(centerX, 0, centerZ);

    previousAccentParents.forEach((parent) => {
      const offset = accentParentOffsets.get(parent.name);
      if (offset) {
        parent.position.x = centerX + offset.x;
        parent.position.z = centerZ + offset.y;
      }
      parent.rotation = new BABYLON.Vector3(0, 0, 0);

      parent.setParent(tempPivot);
    });
  }

  tempPivot.rotation.y = rotationInRadians;

  patternProps.currentAccentRotation = value;
  isSceneDirty = true;
}

function clearAccentRotationPivot() {
  const tempPivot = scene.getTransformNodeByName("accent_temp_pivot");
  if (tempPivot) {
    previousAccentParents.forEach((parent) => {
      if (parent.parent === tempPivot) {
        parent.setParent(null);
      }
    });

    tempPivot.dispose();
  }
}

export function SetPrintTiling(value) {
  // const percentage = minPrintTile + ((value / 10) * (maxPrintTile - minPrintTile));
  //
  // const roundedPercentage = Math.round(percentage);

  patternProps.currentPrintTiling = value;
  // console.log('Value : ', value, ' percentage : ', percentage, ' print tiling : ', patternProps.currentPrintTiling);

  adjustAllPrintTiling();
  isSceneDirty = true;
  // savePattern()
}

function adjustAllPrintTiling() {
  scene.meshes.forEach((mesh) => {
    if (mesh.material && mesh.material instanceof BABYLON.NodeMaterial) {
      // Re-resolve through the shared-material cache first: two accent tiles
      // can carry the exact same mat/print/color combo (and would collapse
      // onto the same cached clone) but still need independently computed
      // UV offsets below, since each is keyed by parent name now.
      mesh.material = RH.GetMeshMaterial(mesh);
      if (
        mesh.metadata &&
        mesh.metadata.print &&
        mesh.metadata.printOriginalTile
      ) {
        const useCustomPrint = mesh.material.getBlockByName("useCustomPrint");

        if (!useCustomPrint.value) {
          const uPrintTileBlock = mesh.material.getBlockByName("uPrintTile");
          const vPrintTileBlock = mesh.material.getBlockByName("vPrintTile");
          const uPrintOffsetBlock =
            mesh.material.getBlockByName("uPrintOffset");
          const vPrintOffsetBlock =
            mesh.material.getBlockByName("vPrintOffset");

          // console.log('Print id : ', mesh.metadata.print, ' tile : ', mesh.metadata.printOriginalTile, ' multiplier : ', patternProps.currentPrintTiling)
          let printMultiplier = patternProps.currentPrintTiling;

          if (mesh.name.startsWith("accent")) {
            printMultiplier *= mesh.scaling.x * mesh.parent.scaling.x;
          }

          if (uPrintTileBlock) {
            uPrintTileBlock.value =
              mesh.metadata.printOriginalTile * printMultiplier;
          }

          if (vPrintTileBlock) {
            vPrintTileBlock.value =
              mesh.metadata.printOriginalTile * printMultiplier;
          }

          // Continuous offset from the tile's own position/scale, instead of
          // the old discrete accentTiling===1|2|3|4 lookup table below (kept
          // for reference) — that table only covered 4 fixed tile counts and
          // produced visibly misaligned prints for any other tiling value or
          // once a tile was dragged off its original grid slot.
          if (mesh.name.startsWith("accent") && mesh.parent) {
            const uTileVal = uPrintTileBlock ? uPrintTileBlock.value : 1.0;
            const vTileVal = vPrintTileBlock ? vPrintTileBlock.value : 1.0;

            const scaleX = mesh.parent.scaling.x || 1.0;
            const scaleZ = mesh.parent.scaling.z || 1.0;

            if (uPrintOffsetBlock) {
              let uOffset = 0.5 + (mesh.parent.position.x * uTileVal) / scaleX;

              uOffset = uOffset % 1;
              if (uOffset < 0) uOffset += 1;
              uPrintOffsetBlock.value = uOffset;
            }

            if (vPrintOffsetBlock) {
              let vOffset = 0.5 + (mesh.parent.position.z * vTileVal) / scaleZ;

              vOffset = vOffset % 1;
              if (vOffset < 0) vOffset += 1;
              vPrintOffsetBlock.value = vOffset;
            }
          } else {
            uPrintOffsetBlock.value = patternProps.currentTemplate.uOffset;
            vPrintOffsetBlock.value = patternProps.currentTemplate.vOffset;
          }

          // if (mesh.name.startsWith("accent")) {
          //   const accentTiling = patternProps.currentAccentNumber;
          //   console.log('Accent tiling : ', accentTiling)
          //   if (uPrintOffset && vPrintOffset) {
          //     if (accentTiling === 1 || accentTiling === 2) {
          //       uPrintOffset.value = 0.5 + mesh.parent.position.x;
          //       vPrintOffset.value = 0.5 + mesh.parent.position.z;
          //     } else if (accentTiling === 3) {
          //       uPrintOffset.value = 0.5;
          //       vPrintOffset.value = 0.5;
          //     } else if (accentTiling === 4) {
          //       uPrintOffset.value = (1 + mesh.parent.position.x) % 1;
          //       if (uPrintOffset.value < 0) uPrintOffset.value += 1;
          //
          //       vPrintOffset.value = (1 + mesh.parent.position.z) % 1;
          //       if (vPrintOffset.value < 0) vPrintOffset.value += 1;
          //     } else {
          //       console.warn(`Unhandled accentTiling value: ${accentTiling}`);
          //     }
          //   }
          // }
        }
      }
    }
  });
}

function adjustAccentMaterialTiling() {
  scene.meshes.forEach((mesh) => {
    if (mesh.material && mesh.material instanceof BABYLON.NodeMaterial) {
      if (
        mesh.metadata &&
        mesh.metadata.material &&
        mesh.metadata.matOriginalTile &&
        mesh.name.startsWith("accent")
      ) {
        const uTile = mesh.material.getBlockByName("uTile");
        const vTile = mesh.material.getBlockByName("vTile");
        const uOffsetBlock = mesh.material.getBlockByName("uOffset");
        const vOffsetBlock = mesh.material.getBlockByName("vOffset");

        const matMultiplier = mesh.scaling.x * mesh.parent.scaling.x;

        if (uTile) {
          uTile.value = mesh.metadata.matOriginalTile * matMultiplier;
        }

        if (vTile) {
          vTile.value = mesh.metadata.matOriginalTile * matMultiplier;
        }

        // Same continuous-offset fix as adjustAllPrintTiling's print blocks,
        // applied to the material (as opposed to print) UV offset — a tiled
        // accent material used to have no live-recomputed offset at all
        // (both blocks were commented out below), so it never tracked the
        // tile's actual position once accents were duplicated/repositioned.
        const uTileVal = uTile ? uTile.value : 1.0;
        const vTileVal = vTile ? vTile.value : 1.0;

        const scaleX = mesh.parent.scaling.x || 1.0;
        const scaleZ = mesh.parent.scaling.z || 1.0;

        if (uOffsetBlock) {
          let uOffset = 0 + (mesh.parent.position.x * uTileVal) / scaleX;

          if (mesh.metadata.material.uOffset)
            uOffset += mesh.metadata.material.uOffset;
          uOffset = uOffset % 1;
          if (uOffset < 0) uOffset += 1;
          uOffsetBlock.value = uOffset;
        }

        if (vOffsetBlock) {
          let vOffset = 0 + (mesh.parent.position.z * vTileVal) / scaleZ;

          if (mesh.metadata.material.vOffset)
            vOffset += mesh.metadata.material.vOffset;
          vOffset = vOffset % 1;
          if (vOffset < 0) vOffset += 1;
          vOffsetBlock.value = vOffset;
        }
      }
    }
  });
}

export function SetAccentScale(value) {
  if (previousAccentParents && previousAccentParents.length > 0) {
    let minScale = 0.1;
    let maxScale = 1;

    const scaleValue = minScale + (value / 100) * (maxScale - minScale);

    // Slider drag events can re-fire the same resolved scaleValue many times
    // per pixel of movement — skip the redundant scene mutation + dirty-flag
    // (and the eventual autosave it queues) when nothing actually changed.
    if (patternProps.currentAccentScale !== scaleValue) {
      const finalScale = scaleValue * individualAccentScale;

      patternProps.currentAccentScale = scaleValue;

      previousAccentParents.forEach((parent) => {
        parent.scaling = new BABYLON.Vector3(finalScale, 1, finalScale);
      });

      isSceneDirty = true;
    }
  }
}

export function SetAccentNumber_1(value) {
  //THIN INSTANCES VERSION
  if (value <= 0 || value > 4 || isNaN(value)) return;
  accentParentOffsets.clear();

  const numberOfAccents = value * value;
  individualAccentScale = 1 / value;
  patternProps.currentAccentNumber = value;

  if (!previousAccentParents || previousAccentParents.length === 0) return;

  const parentToDuplicate = previousAccentParents[0];

  while (previousAccentParents.length > 1) {
    const parentToRemove = previousAccentParents.pop();

    parentToRemove.dispose();
  }

  const templates = templateMeshesCache;
  let centerX = 0,
    centerZ = 0,
    combinedWidth = 0,
    combinedDepth = 0;

  if (templates.length > 0) {
    let min = new BABYLON.Vector3(
      Number.POSITIVE_INFINITY,
      0,
      Number.POSITIVE_INFINITY,
    );
    let max = new BABYLON.Vector3(
      Number.NEGATIVE_INFINITY,
      0,
      Number.NEGATIVE_INFINITY,
    );

    templates.forEach((template) => {
      const boundingBox = template.getBoundingInfo().boundingBox;
      min = BABYLON.Vector3.Minimize(min, boundingBox.minimumWorld);
      max = BABYLON.Vector3.Maximize(max, boundingBox.maximumWorld);
    });

    combinedWidth = max.x - min.x;
    combinedDepth = max.z - min.z;
    centerX = (min.x + max.x) / 2;
    centerZ = (min.z + max.z) / 2;
  }

  const rowCount = value;
  const columnCount = value;
  let scaling = individualAccentScale * patternProps.currentAccentScale;

  parentToDuplicate.getChildren().forEach((child) => {
    if (child instanceof BABYLON.Mesh) {
      const matrixBuffer = new Float32Array(numberOfAccents * 16);

      for (let i = 0; i < numberOfAccents; i++) {
        const row = Math.floor(i / columnCount);
        const col = i % columnCount;

        let xOffset =
          (combinedWidth / columnCount) * (col + 0.5 - columnCount / 2);
        let zOffset = (combinedDepth / rowCount) * (row + 0.5 - rowCount / 2);

        if (!accentParentOffsets.has(`accent_${i}`)) {
          accentParentOffsets.set(`accent_${i}`, { x: xOffset, y: zOffset });
        }

        const instanceScale = new BABYLON.Vector3(scaling, 1, scaling);

        const instanceRotation = child.rotationQuaternion
          ? child.rotationQuaternion
          : BABYLON.Quaternion.RotationYawPitchRoll(
              child.rotation.y,
              child.rotation.x,
              child.rotation.z,
            );

        const instancePosition = new BABYLON.Vector3(
          centerX + xOffset,
          child.position.y,
          centerZ + zOffset,
        );

        const matrix = BABYLON.Matrix.Identity();
        BABYLON.Matrix.ComposeToRef(
          instanceScale,
          instanceRotation,
          instancePosition,
          matrix,
        );

        matrix.copyToArray(matrixBuffer, i * 16);
      }

      child.thinInstanceSetBuffer("matrix", matrixBuffer, 16, false);

      // const colorBuffer = new Float32Array(numberOfAccents * 4);
      // colorBuffer.fill(1.0);
      // child.thinInstanceSetBuffer("instanceColor", colorBuffer, 4, false);
    }
  });

  adjustAllPrintTiling();
  adjustAccentMaterialTiling();
  updateAccentMask();
  isSceneDirty = true;
}

export function SetAccentNumber(value) {
  //INSTANCES VERSION
  if (value <= 0 || value > 4 || isNaN(value)) return;

  clearAccentRotationPivot();

  accentParentOffsets.clear();

  const prevAccentNumber = patternProps.currentAccentNumber;

  if (previousAccentParents && previousAccentParents.length > 0) {
    const numberOfAccents = value * value;
    individualAccentScale = 1 / value;
    patternProps.currentAccentNumber = value;

    const parentToDuplicate = previousAccentParents[0];

    const isSingleTile = value === 1;
    const realChildren = parentToDuplicate
      .getChildren()
      .filter(
        (c) =>
          !c.isAnInstance &&
          c instanceof BABYLON.Mesh &&
          !c.name.includes("inst"),
      );

    // Sync each master child's material/metadata from its accent_0 instance
    // *before* branching on isSingleTile. getMeshMaterial's shared-material
    // cache now keys clones by parent name (see renderHelpers), so two
    // duplicated tiles that were edited identically no longer collapse onto
    // one clone we could just read off any instance — we have to explicitly
    // compare each tile's "visual signature" (the mat/print/color portion of
    // the cache key, with the per-parent suffix stripped) across every
    // previousAccentParents sibling. Only copy across when every tile that
    // exists actually matches (or there's only one tile), so a deliberately
    // different edit on one tile doesn't get clobbered by another's material.
    const signatureRegex = /^sharedMat_(.+)_p[a-zA-Z0-9_]+$/;

    realChildren.forEach((child) => {
      const firstCorrespondingNode = parentToDuplicate
        .getChildren()
        .find((node) => node.name === `accent_0_inst_${child.name}`);

      if (firstCorrespondingNode && firstCorrespondingNode.material) {
        const firstMatch =
          firstCorrespondingNode.material.name.match(signatureRegex);
        const firstVisualSignature = firstMatch
          ? firstMatch[1]
          : firstCorrespondingNode.material.name;
        let allTilesAreIdentical = true;

        for (let pIdx = 1; pIdx < previousAccentParents.length; pIdx++) {
          const currentParent = previousAccentParents[pIdx];
          const siblingNode = currentParent
            .getChildren()
            .find((node) => node.name === `accent_${pIdx}_inst_${child.name}`);

          if (siblingNode && siblingNode.material) {
            const siblingMatch =
              siblingNode.material.name.match(signatureRegex);
            const siblingVisualSignature = siblingMatch
              ? siblingMatch[1]
              : siblingNode.material.name;

            if (siblingVisualSignature !== firstVisualSignature) {
              allTilesAreIdentical = false;
              break;
            }
          } else {
            allTilesAreIdentical = false;
            break;
          }
        }

        if (isSingleTile || allTilesAreIdentical) {
          child.material = firstCorrespondingNode.material;
          child.metadata = cloneMetadataSafely(firstCorrespondingNode.metadata);
          child.setEnabled(firstCorrespondingNode.isEnabled());
        }
      }
    });

    if (isSingleTile) {
      realChildren.forEach((child) => {
        child.isVisible = true;
        child.isPickable = true;
        if (child.metadata && child.metadata.originalPosition) {
          child.position.copyFrom(child.metadata.originalPosition);
        }

        // Superseded by the exact-match sync above, which now runs for both
        // single- and multi-tile cases — this loose `.includes()` match
        // could accidentally hit an unrelated node whose name happened to
        // contain this child's name as a substring.
        // const correspondingNode = parentToDuplicate
        //     .getChildren()
        //     .find((node) => node.name === `accent_0_inst_${child.name}`)
        //
        // if (correspondingNode) {
        //   child.material = correspondingNode.material
        //   child.metadata = cloneMetadataSafely(correspondingNode.metadata)
        //   child.setEnabled(correspondingNode.isEnabled())
        // }
      });

      const instances = parentToDuplicate
        .getChildren()
        .filter((c) => c.name.includes("inst_"));
      instances.forEach((inst) => inst.dispose());

      while (previousAccentParents.length > 1) {
        const parentToRemove = previousAccentParents.pop();
        parentToRemove.dispose();
      }
    } else {
      for (let i = 0; i < numberOfAccents; i++) {
        let targetParent;

        if (i < previousAccentParents.length) {
          targetParent = previousAccentParents[i];
        } else {
          targetParent = new BABYLON.TransformNode(`accent_${i}`, scene);
          const lastParent =
            previousAccentParents[previousAccentParents.length - 1];
          targetParent.position.y = lastParent
            ? lastParent.position.y + 0.0002
            : 0.0002;
          previousAccentParents.push(targetParent);
        }

        realChildren.forEach((child) => {
          const instanceName = `accent_${i}_inst_${child.name}`;
          let existingInstance = targetParent
            .getChildren()
            .find((c) => c.name === instanceName);

          if (!existingInstance) {
            // A true GPU instance (createInstance) always shares its source
            // mesh's material — fine for a blank/default tile, but it means
            // every tile with a per-tile print/color edit rendered whatever
            // the *master* tile currently had instead of its own. Clone
            // instead whenever the tile actually needs its own material so
            // each one can carry an independent mesh.material.
            const matId = child.metadata?.material?.id ?? "null";
            const printId =
              child.metadata?.print?.egoID ??
              child.metadata?.print?.id ??
              "null";
            const needsUniqueMaterial = matId !== "null" || printId !== "null";

            if (needsUniqueMaterial) {
              existingInstance = child.clone(instanceName, targetParent);
              existingInstance.isVisible = true;
            } else {
              existingInstance = child.createInstance(instanceName);
            }
            existingInstance.metadata = cloneMetadataSafely(child.metadata);

            if (child.metadata && child.metadata.originalPosition) {
              existingInstance.position.copyFrom(
                child.metadata.originalPosition,
              );
            } else {
              existingInstance.position.copyFrom(child.position);
              if (!child.metadata) child.metadata = {};
              child.metadata.originalPosition = child.position.clone();
            }

            existingInstance.scaling.copyFrom(child.scaling);
            if (child.rotationQuaternion)
              existingInstance.rotationQuaternion =
                child.rotationQuaternion.clone();
            else existingInstance.rotation.copyFrom(child.rotation);

            existingInstance.parent = targetParent;
            existingInstance.renderingGroupId = 1;
            existingInstance.setEnabled(child.isEnabled());
            // existingInstance.isPickable = true;

            if (child.name.includes("_Merge") && currentMerges[child.name]) {
              const masterPieces = currentMerges[child.name];
              const parentPrefix = parentToDuplicate.name;
              const newPrefix = `accent_${i}`;

              const instancePieces = masterPieces.map((pieceName) => {
                let cleanName = pieceName.startsWith(parentPrefix + ".")
                  ? pieceName.replace(parentPrefix + ".", "")
                  : pieceName;
                return `${newPrefix}_inst_${cleanName}`;
              });

              if (!existingInstance.metadata) existingInstance.metadata = {};
              existingInstance.metadata.mergeData = instancePieces;
              currentMerges[existingInstance.name] = instancePieces;
            }
          }
        });
      }

      while (previousAccentParents.length > numberOfAccents) {
        const parentToRemove = previousAccentParents.pop();
        parentToRemove.dispose();
      }

      realChildren.forEach((child) => {
        child.isVisible = false;
        // child.isPickable = false;
        // child.position.y = -99999;
      });
    }

    RH.SetOverlayMesh();

    const templates = templateMeshesCache;

    if (templates.length > 0) {
      let min = new BABYLON.Vector3(
        Number.POSITIVE_INFINITY,
        0,
        Number.POSITIVE_INFINITY,
      );
      let max = new BABYLON.Vector3(
        Number.NEGATIVE_INFINITY,
        0,
        Number.NEGATIVE_INFINITY,
      );

      templates.forEach((template) => {
        const boundingBox = template.getBoundingInfo().boundingBox;
        min = BABYLON.Vector3.Minimize(min, boundingBox.minimumWorld);
        max = BABYLON.Vector3.Maximize(max, boundingBox.maximumWorld);
      });

      const combinedWidth = max.x - min.x;
      const combinedDepth = max.z - min.z;

      const rowCount = value;
      const columnCount = value;

      let scaling = individualAccentScale * patternProps.currentAccentScale;

      const centerX = (min.x + max.x) / 2;
      const centerZ = (min.z + max.z) / 2;

      for (let i = 0; i < previousAccentParents.length; i++) {
        const row = Math.floor(i / columnCount);
        const col = i % columnCount;

        const accent = previousAccentParents[i];

        let xOffset =
          (combinedWidth / columnCount) * (columnCount / 2 - col - 0.5);
        let zOffset = (combinedDepth / rowCount) * (row + 0.5 - rowCount / 2);

        if (!accentParentOffsets.has(accent.name)) {
          accentParentOffsets.set(accent.name, { x: xOffset, y: zOffset });
        }

        accent.position.x = centerX + xOffset;
        accent.position.z = centerZ + zOffset;

        // accent.getChildren().forEach((child) => {
        //
        //   if (child.name.includes('Merge') && currentMerges[child.name]) {
        //   }
        // })

        accent.scaling = new BABYLON.Vector3(scaling, 1, scaling);
      }
    }

    adjustAllPrintTiling();
    adjustAccentMaterialTiling();
    updateAccentMask();

    isSceneDirty = true;
  }
}

function cloneMetadataSafely(sourceMeta) {
  if (!sourceMeta) return {};

  const newMeta = {};

  for (const key in sourceMeta) {
    const value = sourceMeta[key];

    if (value === null || value === undefined) {
      newMeta[key] = value;
    } else if (key === "material" || typeof value.getClassName === "function") {
      newMeta[key] = value;
    } else if (Array.isArray(value)) {
      newMeta[key] = [...value];
    } else if (typeof value === "object") {
      newMeta[key] = { ...value };
    } else {
      newMeta[key] = value;
    }
  }

  return newMeta;
}

function areStylesSame(meshA, meshB) {
  if (!meshA || !meshB) {
    console.warn("One or both meshes are undefined.");
    return false;
  }

  if (
    (meshA.metadata?.material?.id || null) !==
    (meshB.metadata?.material?.id || null)
  ) {
    return false;
  }

  if (
    (meshA.metadata?.print?.id || null) !== (meshB.metadata?.print?.id || null)
  ) {
    return false;
  }

  const colorProps = ["colorR", "colorG", "colorB", "colorA"];
  for (const prop of colorProps) {
    const colorA = meshA.metadata?.[prop];
    const colorB = meshB.metadata?.[prop];

    if (colorA && colorB) {
      const blockA = meshA.material.getBlockByName(prop);
      const blockB = meshB.material.getBlockByName(prop);

      if (blockA?.value.toHexString() !== blockB?.value.toHexString()) {
        return false;
      }
    }
  }

  return true;
}

export function CheckCurrentMode(mode) {
  // console.log('CHECK CURRENT MODE : ', mode)

  if (mode === 0) {
    savePattern();
  }
  if (
    mode != APPLICATION_MODES.PICKER_PICKED &&
    mode != APPLICATION_MODES.PICKER_PICKING
  )
    RH.HideHighlightForSource();

  if (mode != APPLICATION_MODES.HIDE_SURFACES) {
    if (applicationMode == APPLICATION_MODES.HIDE_SURFACES) {
      applicationMode = APPLICATION_MODES.NONE;
      removeAllHiddenMeshesHighlight();
    }
  }

  if (mode === APPLICATION_MODES.HIDE_SURFACES) showAllHiddenMeshesHighlight();
}

export function SetCurrentItem(selection, tab) {
  // console.log(`SET CURRENT ITEM : ${selection}, TAB ${tab}`)
  if (applicationMode === APPLICATION_MODES.FULL_SCREEN) {
    toggleCameraForFullscreen(false);
  }

  applicationMode = APPLICATION_MODES.NONE;
  clearPartialActions();
  if (
    ["accent", "template", "scene", "boarder", "frame", "matting"].indexOf(
      tab,
    ) + 1 &&
    !selection?.clicked
  )
    return;

  // if (tab === 'upload' && selection?.print && selection.print?.startsWith('egoID')) {
  //   tab = 'print'
  // }

  function success(result) {
    if (result) savePattern();
  }

  function updateCurrentItem(item) {
    currentItem = item;
    if (!currentItem) applicationMode = APPLICATION_MODES.NONE;
  }

  switch (tab) {
    case "template":
      if (
        selection.template != null &&
        (!patternProps.currentTemplate ||
          selection.template != patternProps.currentTemplate.id)
      ) {
        getTemplate(selection.template)
          .then(applyTemplate)
          .then((result) => {
            savePattern(true, () => {
              // reset boarder after changing template for gallery only
              // if (topicType === 'gallery') {
              //   applyBoarders()
              //   applyMattings()
              // }
            });
            createClippingMask();
          });
      }
      break;
    case "accent":
      // console.log(`Selection accent : ${selection.accent}, current : ${patternProps.currentAccentID}`)
      // if (topicType === 'gallery') {
      //   if (selection.accent) applicationMode = APPLICATION_MODES.APPLY_ACCENT
      //   const find = Assets.accents.find((i) => i.id === selection.accent)
      //   updateCurrentItem(find)
      // console.log(`This apply accent to gallery, skip slider visibility`)
      // toggleSliderVisibility(true)
      // } else
      if (selection.accent != patternProps.currentAccentID) {
        applySingleAccent(selection.accent)
          .then((result) => {
            // Call the success function
            success();

            if (previousAccentParents.length > 0)
              collectInitialAccentUVs(previousAccentParents[0]);

            // Add additional logic here
            console.log("applySingleAccent finished, result:", result);

            updateAccentMask();
            currentMerges = {};
          })
          .catch((err) => {
            // Handle errors
            console.error("Error in applySingleAccent:", err);
          });
      } else {
        unsetAccent();
        success(true);
      }
      break;
    case "frame":
      console.log(
        `Selection frame : ${selection.frame}, current : ${patternProps.currentFrameID}`,
      );
      if (selection.frame != patternProps.currentFrameID) {
        if (topicType === "gallery") {
          applyGalleryFrame(selection.frame);
        } else if (topicType === "pattern") {
          applyPatternFrame(selection.frame);
        }

        savePattern();
        // applySingleAccent(selection.accent).then(success)
      } else {
        unsetFrame();
        success(true);
        savePattern();
      }
      break;
    case "patternFrame":
      console.log(
        `Selection frame : ${selection.frame}, current : ${patternProps.currentFrameID}`,
      );
      // patternProps.currentPatternFrameID = selection.patternFrame
      if (selection.frame != patternProps.currentFrameID) {
        applyPatternFrame(selection.frame);
        savePattern();
        // applySingleAccent(selection.accent).then(success)
      }
      // console.log(`Selection frame : ${selection.patternFrame}, current : ${patternProps.currentPatternFrameID}`)
      break;
    case "scene":
      if (selection.scene != patternProps.currentSceneID)
        getScene(selection.scene).then(applyScene).then(success);
      else {
        unsetScene();
        success(true);
      }
      break;
    case "material":
      applicationMode = APPLICATION_MODES.APPLY_MATERIAL;
      getMaterial(selection.material)
        .then(updateCurrentItem)
        .catch(() => updateCurrentItem(null));
      break;
    case "pattern":
      applicationMode = APPLICATION_MODES.APPLY_PATTERN;
      getPrint(selection.pattern)
        .then(updateCurrentItem)
        .catch(() => updateCurrentItem(null));
      break;
    case "print":
    case "upload":
    case "album":
      applicationMode = APPLICATION_MODES.APPLY_PRINT;
      getPrint(selection.print)
        .then(updateCurrentItem)
        .catch(() => updateCurrentItem(null));
      break;
    case "color":
      if (selection.color) applicationMode = APPLICATION_MODES.APPLY_COLOR;
      // eslint-disable-next-line no-case-declarations
      const find = Assets.colors.find((i) => i.hex[0] === selection.color);
      if (find) {
        const updatedFind = {
          ...find,
          hex: [removeCustomIdentifier(find.hex[0]), ...find.hex.slice(1)],
        };

        updateCurrentItem(updatedFind);
      } else {
        console.log("No matching color found");
        // Unlike the 'material'/'pattern'/'print' cases above, this branch
        // used to leave applicationMode armed as APPLY_COLOR without ever
        // setting currentItem, so a click on the canvas after an unmatched
        // color hit `currentItem.hex` on a null currentItem in onCanvasUp.
        // updateCurrentItem(null) resets applicationMode back to NONE, same
        // safety net the other tabs already rely on.
        updateCurrentItem(null);
      }
      // updateCurrentItem(find)
      break;
    case "text":
      return;
    // case 'boarder':
    //   // eslint-disable-next-line no-case-declarations
    //   const int = parseInt(selection.boarder.width)
    //   // eslint-disable-next-line no-case-declarations
    //   const factors = [0, 5, 10, 20, 25, 50, 100]
    //   // eslint-disable-next-line no-case-declarations
    //   const newBoarderWidth = parseFloat(factors.find((factor) => int <= factor) / 100)
    //   if (
    //     patternProps.boarderType !== selection.boarder.type ||
    //     patternProps.boarderWidth !== newBoarderWidth
    //   ) {
    //     patternProps.boarderType = selection.boarder.type
    //     patternProps.boarderWidth = newBoarderWidth
    //     updateBoarder()
    //     savePattern()
    //   }
    //   return
    case "matting":
      // Commented out because matting should work without frame
      // if (!patternProps.currentFrameID) return
      // eslint-disable-next-line no-case-declarations
      const intWidth = parseInt(selection.matting.width);
      // eslint-disable-next-line no-case-declarations
      const mattingFactors = [0, 5, 10, 20]; //, 25, 50, 100]
      // eslint-disable-next-line no-case-declarations
      const newMattingWidth = parseFloat(
        mattingFactors.find((factor) => intWidth <= factor) / 100,
      );
      if (patternProps.mattingWidth !== newMattingWidth) {
        patternProps.mattingWidth = newMattingWidth;
        updateMatting();
        savePattern();
      }
      return;
    default:
      break;
  }
}

function updateAccentMask() {
  // const temporaryAccentMeshes = []
  //
  // previousAccentParents.forEach((parent) => {
  //   const childMeshes = parent.getChildMeshes()
  //
  //   temporaryAccentMeshes.push(...childMeshes)
  // })
  // console.log("Total child meshes in previousAccentParents:", temporaryAccentMeshes.length);
  // console.log("Clipping Planes:", clippingPlanes);
  // temporaryAccentMeshes.forEach((mesh) => {
  //   if (mesh.material) {
  //
  //     if (mesh._hasClipPlanesAttached) return;
  //
  //     mesh.onBeforeRenderObservable.add(() => {
  //       scene.clipPlane = clippingPlanes[0]
  //       scene.clipPlane2 = clippingPlanes[1]
  //       scene.clipPlane3 = clippingPlanes[2]
  //       scene.clipPlane4 = clippingPlanes[3]
  //     })
  //
  //     mesh.onAfterRenderObservable.add(() => {
  //       scene.clipPlane = null
  //       scene.clipPlane2 = null
  //       scene.clipPlane3 = null
  //       scene.clipPlane4 = null
  //     })
  //     mesh._hasClipPlanesAttached = true;
  //   } else {
  //     console.log('Material not a node material')
  //   }
  // })
}

function removeCustomIdentifier(color) {
  if (!color) return "";
  return color.includes("-custom") ? color.replace("-custom", "") : color;
}

export function UpdateAddColorHex(selectedColors) {
  const addColorItem = Assets.colors.find((item) => item.name === "AddColor");

  if (addColorItem) {
    addColorItem.hex = [...selectedColors];

    // console.log(`Updated 'AddColor' hex values:`, addColorItem.hex);
  } else {
    console.error("'AddColor' item not found in Assets.colors");
  }
}

function createLights() {
  let light;
  if (topicType == "pattern" || topicType == "custom_print") {
    light = new BABYLON.HemisphericLight(
      "light1",
      new BABYLON.Vector3(0, 1, 0),
      scene,
    );
    light.intensity = 0.9;

    light.diffuse = new BABYLON.Color3(1, 1, 1);
    light.groundColor = new BABYLON.Color3(1, 1, 1);
  } else {
    light = new BABYLON.DirectionalLight(
      "light1",
      new BABYLON.Vector3(0, -0.866, 0.5),
      scene,
    );
    light.intensity = 3;
    light.position.set(0, 300, 0);

    shadowGenerator = new BABYLON.ShadowGenerator(2048, light);

    shadowGenerator.usePoissonSampling = true;
    shadowGenerator.usePercentageCloserFiltering = true;
    // shadowGenerator.useContactHardeningShadow = true;
    shadowGenerator.bias = 0.0002;
    shadowGenerator.normalBias = 0.01;
    shadowGenerator.setDarkness(0.25);
  }

  // console.log('Create light : ', light.name)
}

function clearShadowCasters() {
  const shadowCasters = shadowGenerator.getShadowMap().renderList;

  while (shadowCasters.length > 0) {
    shadowGenerator.removeShadowCaster(shadowCasters[0]);
  }
}

function createScene() {
  scene = new BABYLON.Scene(engine);
  window.scene = scene;

  scene.setRenderingAutoClearDepthStencil(1, false, false, false);

  scene.onBeforeRenderingGroupObservable.add((info) => {
    if (
      info.renderingGroupId === 1 &&
      clippingPlanes &&
      clippingPlanes.length === 4
    ) {
      scene.clipPlane = clippingPlanes[0];
      scene.clipPlane2 = clippingPlanes[1];
      scene.clipPlane3 = clippingPlanes[2];
      scene.clipPlane4 = clippingPlanes[3];
    }
  });

  scene.onAfterRenderingGroupObservable.add((info) => {
    if (info.renderingGroupId === 1) {
      scene.clipPlane = null;
      scene.clipPlane2 = null;
      scene.clipPlane3 = null;
      scene.clipPlane4 = null;
    }
  });

  if (grabbable) {
    scene.onKeyboardObservable.add((kbInfo) => {
      switch (kbInfo.type) {
        case BABYLON.KeyboardEventTypes.KEYDOWN:
          if (kbInfo.event.key === "Alt") {
            scene.defaultCursor = "grab";
          }
          break;
        case BABYLON.KeyboardEventTypes.KEYUP:
          break;
      }
    });
  }

  // scene.debugLayer.show({
  //   embedMode: false, // Ensures the Inspector is overlaid on top of the canvas
  //   overlay: true,    // Keeps the Inspector as an overlay
  //   handleResize: true,
  // });
}

function createClippingMask() {
  if (topicType != "pattern" && topicType != "custom_print") return;

  // const templateMeshes = scene.meshes.filter((mesh) => mesh.name.startsWith('template'))
  const templateMeshes = templateMeshesCache;

  if (templateMeshes.length === 0) {
    console.error("No template meshes found for clipping bounds.");
    return;
  }

  let minX = Infinity,
    minY = Infinity,
    minZ = Infinity;
  let maxX = -Infinity,
    maxY = -Infinity,
    maxZ = -Infinity;

  templateMeshes.forEach((mesh) => {
    const boundingInfo = mesh.getBoundingInfo();
    const boundingMin = boundingInfo.boundingBox.minimumWorld;
    const boundingMax = boundingInfo.boundingBox.maximumWorld;

    minX = Math.min(minX, boundingMin.x);
    minZ = Math.min(minZ, boundingMin.z);

    maxX = Math.max(maxX, boundingMax.x);
    maxZ = Math.max(maxZ, boundingMax.z);
  });

  const delta = 0.0001;
  minX += delta;
  maxX -= delta;
  minZ += delta;
  maxZ -= delta;

  // console.log("Bounding Box: minX:", minX, "maxX:", maxX, "minY:", minY, "maxY:", maxY, "minZ:", minZ, "maxZ:", maxZ);
  clippingPlanes = [
    new BABYLON.Plane(1, 0, 0, minX),
    new BABYLON.Plane(-1, 0, 0, minX),
    new BABYLON.Plane(0, 0, 1, minZ),
    new BABYLON.Plane(0, 0, -1, minZ),
  ];

  // console.log("Finish created clipping mask")
}

function createCamera() {
  camera = new BABYLON.ArcRotateCamera(
    "patternEditorCamera",
    -Math.PI / 2,
    Math.PI / 2,
    5,
    new BABYLON.Vector3(0, 0, 0),
    scene,
  );
  camera.setPosition(new BABYLON.Vector3(0, 5, 0));
  camera.setTarget(new BABYLON.Vector3(0, 0, 0));
  camera.attachControl(null, null, false, false);
  camera.upperBetaLimit = 0.2;
  camera.lowerBetaLimit = -0.2;
  camera.upperAlphaLimit = Math.PI / 2;
  camera.lowerAlphaLimit = Math.PI / 2;
  camera.upperRadiusLimit = 15;
  camera.lowerRadiusLimit = 1.2;
  camera.wheelPrecision = 100;
  camera.angularSensibilityY = 10000;
  camera.radius = 2;
  camera.minZ = 0.1;
}

/**
 * @param {HTMLCanvasElement} canvas
 */
let resizeHandler = null;
function setBindings(canvas) {
  engine.runRenderLoop(() => {
    if (outlineNeedsUpdate) {
      RH.UpdateTemplateOutline();
      outlineNeedsUpdate = false;
    }
    scene.render();
    // fpsElem.innerHTML = scene._engine.getFps().toFixed() + ' fps'
  });

  if (resizeHandler) {
    window.removeEventListener("resize", resizeHandler);
  }
  canvas.removeEventListener("pointerdown", onCanvasDown);
  canvas.removeEventListener("pointermove", onCanvasMove);
  canvas.removeEventListener("pointerup", onCanvasUp);

  resizeHandler = () => onWindowResize(canvas);

  window.addEventListener("resize", resizeHandler);

  window.addEventListener("pointerup", () => {
    if (isSceneDirty) {
      clearAccentRotationPivot();
      const lastPattern = patternHistory[historyIndex - 1];

      const hasAccentChanged =
        !lastPattern ||
        lastPattern.accentScale !== patternProps.currentAccentScale ||
        lastPattern.accentNumber !== patternProps.currentAccentNumber ||
        lastPattern.accentRotation !== patternProps.currentAccentRotation;

      if (hasAccentChanged) {
        savePattern(true);
      } else {
        savePattern(false);
      }
      RH.SafelyDisposeMaterials();
      isSceneDirty = false;
    }
  });
  canvas.addEventListener("pointerdown", onCanvasDown);
  canvas.addEventListener("pointermove", onCanvasMove);
  canvas.addEventListener("pointerup", onCanvasUp);
}

function onCanvasDown(event) {
  didCanvasDown = true;
  downPoint.set(event.clientX, event.clientY);
  downTime = new Date().getTime();
  previousPickedMesh = null;
  if (event.ctrlKey && applicationMode !== APPLICATION_MODES.FULL_SCREEN) {
    isCtrlPointer = true;
    camera.detachControl();
  }
  startX = event.offsetX;
  startZ = event.offsetY;
}

function onCanvasMove(event) {
  if (!event.altKey) {
    scene.defaultCursor = "auto";
  }
  if (event.altKey && didCanvasDown && grabbable) {
    // scene.meshes.forEach((mesh) => {
    //   if (mesh.getBehaviorByName('PointerDrag')) {
    //     mesh._behaviors[0].enabled = false
    //   }
    // })
    const offsetX = event.offsetX - startX;
    const offsetY = event.offsetY - startZ;
    const { width, height } = event.srcElement.getBoundingClientRect(); // canvas width and height
    const radius = camera.radius;
    camera.setTarget(
      new BABYLON.Vector3(
        camera.target._x + (offsetX / width) * radius,
        0,
        camera.target._z - (offsetY / height) * radius,
      ),
    );
    camera.radius = radius;

    startX = event.offsetX;
    startZ = event.offsetY;
    return;
  }

  if (mode === "edit") {
    // scene.meshes.forEach((mesh) => {
    //   if (mesh.getBehaviorByName('PointerDrag')) {
    //     mesh._behaviors[0].enabled = true
    //   }
    // })
  }

  if (!(didCanvasDown && isCtrlPointer)) return;

  // const pickingInfo = scene.pick(scene.pointerX, scene.pointerY)
  const pickingInfo = scene.pick(scene.pointerX, scene.pointerY, (mesh) => {
    if (!mesh.isPickable || !mesh.isEnabled()) return false;

    if (mesh.name.startsWith("scene")) return false;

    if (mesh.name.startsWith("hidden_")) return false;

    if (mesh.isVisible === false || mesh.visibility === 0) return false;

    return true;
  });
  const pickedMesh = pickingInfo.pickedMesh;
  console.log(`PICKED MESH : ${pickedMesh.name}, mode: ${applicationMode}`);
  if (!pickedMesh) return;

  if (pickedMesh.isAnInstance) {
    const masterMesh = pickedMesh.sourceMesh;
  }
  // else {
  //
  //   console.log(`%c [CLICKED THE MASTER] %c ${pickedMesh.name} `, 'background: #8e44ad; color: white;', 'background: #2c3e50; color: white;');
  //
  // }
  if (!pickedMesh || previousPickedMesh == pickedMesh) return;
  switch (applicationMode) {
    case APPLICATION_MODES.APPLY_PRINT:
    case APPLICATION_MODES.APPLY_PATTERN:
      applyPrint(pickedMesh, currentItem);
      break;
    case APPLICATION_MODES.APPLY_COLOR:
      // applyColor(pickedMesh, currentItem.hex)
      applyColorArray(pickedMesh, currentItem.hex);
      break;
    case APPLICATION_MODES.MERGE_SURFACES:
    case APPLICATION_MODES.SPLIT_SURFACES:
      if (meshesSelectedForMerging.has(pickedMesh))
        meshesSelectedForMerging.delete(pickedMesh);
      else {
        if (applicationMode === APPLICATION_MODES.MERGE_SURFACES) {
          if (
            pickedMesh.name.startsWith("boarder_") ||
            pickedMesh.name.startsWith("accent_")
          ) {
            meshesSelectedForMerging.add(pickedMesh);
          }
        } else if (pickedMesh.name.endsWith("_Merge")) {
          meshesSelectedForMerging.add(pickedMesh);
        }
      }
      RH.ShowHighlightOn(meshesSelectedForMerging);
      break;
    // case APPLICATION_MODES.HIDE_SURFACES:
    //   // console.log('Pick mesh ', pickedMesh.name, ' for hiding')
    //   break
    case APPLICATION_MODES.PICKER_PICKED:
      copyStyle(pickedMesh, sourceMesh);
      break;
    default:
      break;
  }

  previousPickedMesh = pickedMesh;
}

function onCanvasUp(event) {
  didCanvasDown = false;
  upPoint.set(event.clientX, event.clientY);
  //detach camera so that during the ctrl pick event camera doesn't rotate
  if (!isCtrlPointer && applicationMode !== APPLICATION_MODES.FULL_SCREEN)
    camera.attachControl(null, null, false, false);

  if (isCtrlPointer && !mergeMode) {
    isCtrlPointer = false;
    savePattern(true, async () => {
      applySurfaceProperties();
    });
  }
  isCtrlPointer = false;

  //check if this was a clicky type pointer up
  const distSq = BABYLON.Vector2.DistanceSquared(upPoint, downPoint);
  const timeDiff = new Date().getTime() - downTime;
  if (distSq > 17 || timeDiff > 400) {
    return;
  }

  const pickingInfo = scene.pick(scene.pointerX, scene.pointerY);
  let pickedMesh = pickingInfo.pickedMesh;

  if (!pickedMesh) return;

  if (pickedMesh.isAnInstance) {
    pickedMesh = shatterInstance(pickedMesh);
  }

  // console.log(`Picked mesh : ${pickedMesh}`)
  if (!pickedMesh || pickedMesh.name.startsWith("scene")) return;
  // if(pickedMesh.name.startsWith('frame') && (applicationMode != APPLICATION_MODES.APPLY_COLOR && applicationMode != APPLICATION_MODES.APPLY_MATERIAL))
  //   return;

  switch (applicationMode) {
    case APPLICATION_MODES.APPLY_MATERIAL:
      if (APPLYTOALL_ACTIVE) {
        applyMaterialOnSameSurfaces(pickedMesh, currentItem, true);
      } else applyMaterialOnSameSurfaces(pickedMesh, currentItem);
      break;
    case APPLICATION_MODES.APPLY_PRINT:
    case APPLICATION_MODES.APPLY_PATTERN:
      if (APPLYTOALL_ACTIVE) applyPrintToAllMeshes(pickedMesh, currentItem);
      else applyPrint(pickedMesh, currentItem);
      break;
    case APPLICATION_MODES.APPLY_ACCENT:
      if (
        pickedMesh.name.includes("boarder") ||
        pickedMesh.name.includes("accent")
      )
        return;

      if (pickedMesh.metadata.accentID === currentItem.id) {
        RH.EmptySceneOfMeshes(`${pickedMesh.name}_accent`);
        pickedMesh.metadata.accentID = null;
        toggleSliderVisibility(false);
      } else {
        applyAccentForMesh(pickedMesh, currentItem, true);
      }
      break;
    case APPLICATION_MODES.APPLY_COLOR:
      if (APPLYTOALL_ACTIVE) applyColorToAllMesh(pickedMesh, currentItem.hex);
      else applyColorArray(pickedMesh, currentItem.hex);
      // applyColor(pickedMesh, currentItem.hex)
      break;
    case APPLICATION_MODES.MERGE_SURFACES:
    case APPLICATION_MODES.SPLIT_SURFACES:
      if (meshesSelectedForMerging.has(pickedMesh))
        meshesSelectedForMerging.delete(pickedMesh);
      else {
        if (applicationMode === APPLICATION_MODES.MERGE_SURFACES) {
          if (
            pickedMesh.name.startsWith("boarder_") ||
            pickedMesh.name.startsWith("accent_")
          ) {
            meshesSelectedForMerging.add(pickedMesh);
          }
        } else if (pickedMesh.name.endsWith("_Merge")) {
          meshesSelectedForMerging.add(pickedMesh);
        }
      }
      RH.ShowHighlightOn(meshesSelectedForMerging);
      break;
    case APPLICATION_MODES.HIDE_SURFACES:
      if (!pickedMesh.name.startsWith("accent")) {
        return;
      }
      if (typeof pickedMesh.metadata.hidden === "undefined") {
        pickedMesh.metadata.hidden = true;
      } else {
        pickedMesh.metadata.hidden = !pickedMesh.metadata.hidden;
      }
      renderMeshHidden(pickedMesh);
      savePattern(); // Save pattern after hiding/unhiding mesh
      break; // Prevent fall-through to next case
    // RH.ShowHighlightForHiding(pickedMesh);
    case APPLICATION_MODES.ROTATE_TILE:
      if (!pickedMesh.metadata.print) return;
      if (!pickedMesh.metadata.print.rotation)
        pickedMesh.metadata.print.rotation = Math.PI / 4;
      else {
        pickedMesh.metadata.print.rotation += Math.PI / 4;
        pickedMesh.metadata.print.rotation %= Math.PI * 2;
      }
      updateTileRotation(pickedMesh);
      savePattern(); // Save pattern after rotating tile
      break;
    case APPLICATION_MODES.PICKER_PICKING:
      sourceMesh = pickedMesh;
      RH.ShowHighlightForSource(sourceMesh, true);
      setMode(APPLICATION_MODES.PICKER_PICKED);
      break;
    case APPLICATION_MODES.PICKER_PICKED:
      copyStyle(pickedMesh, sourceMesh);
      break;
    default:
      return;
  }

  savePattern(true, async () => {
    // applySurfaceProperties()
  });
}

/**
 * @param {HTMLCanvasElement} canvas
 */
function onWindowResize(canvas) {
  if (canvas.parentElement) {
    canvas.width = canvas.parentElement.clientWidth;
    canvas.height = canvas.parentElement.clientHeight;
    engine.resize();
  }
}

function shatterInstance(instancedMesh, cloneChildren = true) {
  if (!instancedMesh || !instancedMesh.isAnInstance) {
    return instancedMesh;
  }

  // console.trace(
  //     `%c [SHATTER INSTANCE] %c Breaking instance into real mesh: ${instancedMesh.name} `,
  //     'background: #e74c3c; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;',
  //     'background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;'
  // );

  const masterMesh = instancedMesh.sourceMesh;

  const realMesh = masterMesh.clone(instancedMesh.name, null, !cloneChildren);
  realMesh.parent = instancedMesh.parent;

  realMesh.isVisible = true;
  realMesh.setEnabled(true);

  // const sourceMeta = instancedMesh.metadata || masterMesh.metadata;
  const mergedMeta = {
    ...(masterMesh.metadata || {}),
    ...(instancedMesh.metadata || {}),
  };
  realMesh.metadata = cloneMetadataSafely(mergedMeta);

  realMesh.position.copyFrom(instancedMesh.position);
  realMesh.scaling.copyFrom(instancedMesh.scaling);

  if (instancedMesh.rotationQuaternion) {
    realMesh.rotationQuaternion = instancedMesh.rotationQuaternion.clone();
  } else {
    realMesh.rotation.copyFrom(instancedMesh.rotation);
  }

  realMesh.setEnabled(true);

  instancedMesh.dispose();

  return realMesh;
}

function renderMeshHidden(targetMesh, hideOutline = false) {
  let mesh = targetMesh;
  if (mesh.isAnInstance) {
    mesh = shatterInstance(mesh, false);
  }

  if (!transparentMaterial) {
    transparentMaterial = new BABYLON.StandardMaterial(
      "transparentMaterial",
      scene,
    );
    transparentMaterial.alpha = 0;
    transparentMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
    transparentMaterial.backFaceCulling = false;
  }
  if (mesh.metadata.hidden) {
    let childName = `hidden_${mesh.name}`;
    let existingChild = mesh
      .getChildMeshes()
      .find((child) => child.name === childName);

    if (!existingChild) {
      let hiddenMesh = mesh.clone(childName, null, true);

      hiddenMesh.position = new BABYLON.Vector3(0, 0, 0);
      hiddenMesh.rotation = new BABYLON.Vector3(0, 0, 0);
      hiddenMesh.scaling = new BABYLON.Vector3(1, 1, 1);

      hiddenMesh.parent = mesh;

      hiddenMesh.position = new BABYLON.Vector3(0, 0, 0);
      hiddenMesh.rotation = new BABYLON.Vector3(0, 0, 0);
      hiddenMesh.scaling = new BABYLON.Vector3(1, 1, 1);

      hiddenMesh.material = transparentMaterial;
      // hiddenMesh.isPickable = false
      hiddenMesh.visibility = 1;
      hiddenMesh.setEnabled(true);

      mesh.visibility = 0;
      if (!hideOutline) {
        RH.ShowHighlightForHiding(hiddenMesh);
      }
    } else existingChild.setEnabled(true);
    mesh.setEnabled(true);
  } else {
    let hiddenChild = mesh
      .getChildMeshes()
      .find((child) => child.name.startsWith("hidden_"));
    if (hiddenChild) {
      hiddenChild.dispose();
    }
    mesh.visibility = 1;
  }
}

function removeAllHiddenMeshesHighlight() {
  scene.transformNodes.forEach((transformNode) => {
    transformNode.getChildMeshes().forEach((mesh) => {
      if (!scene.meshes.includes(mesh)) {
        scene.addMesh(mesh);
      }
    });
  });

  scene.meshes.forEach((mesh) => {
    if (mesh.name.startsWith("accent") && mesh.metadata?.hidden) {
      mesh.setEnabled(false);
    }
  });
}

function showAllHiddenMeshesHighlight() {
  const meshesToRenderHidden = [];

  scene.meshes.forEach((mesh) => {
    if (!mesh.name.startsWith("accent")) return;

    const instanceHidden = mesh.metadata?.hidden === true;
    const sourceMeshHidden =
      mesh.isAnInstance && mesh.sourceMesh?.metadata?.hidden === true;
    const hasDivergence = !instanceHidden && sourceMeshHidden;

    if (hasDivergence) {
      const shattered = shatterInstance(mesh, false);
      // shattered.metadata.hidden = instanceHidden;
      // shattered.metadata = cloneMetadataSafely(mesh);
      // renderMeshHidden(shattered);
      return;
    }

    if (instanceHidden) {
      meshesToRenderHidden.push(mesh);
    }
  });

  meshesToRenderHidden.forEach((mesh) => renderMeshHidden(mesh));
}

function isPatternEqual(objA, objB) {
  if (objA === objB) return true;

  if (!objA || !objB) return false;

  if (typeof objA !== typeof objB) return false;

  if (typeof objA === "number") {
    return Math.abs(objA - objB) < 0.0001;
  }

  if (typeof objA !== "object") return false;

  if (Array.isArray(objA)) {
    if (!Array.isArray(objB) || objA.length !== objB.length) return false;
    for (let i = 0; i < objA.length; i++) {
      if (!isPatternEqual(objA[i], objB[i])) return false;
    }
    return true;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, key)) return false;

    if (!isPatternEqual(objA[key], objB[key])) return false;
  }

  return true;
}

function serializePattern(isNew) {
  let data = {
    templateID: patternProps.currentTemplate?.id || 0,
    accentID: patternProps.currentAccentID,
    frameID: patternProps.currentFrameID ?? null,
    // patternFrameID: patternProps.currentPatternFrameID,
    sceneID: patternProps.currentSceneID,
    // boarder: {
    //   width: patternProps.boarderWidth,
    //   type: patternProps.boarderType,
    // },
    matting: {
      width: patternProps.mattingWidth,
    },
    accentScale: patternProps.currentAccentScale,
    accentNumber: patternProps.currentAccentNumber,
    accentRotation: patternProps.currentAccentRotation,
    printTiling: patternProps.currentPrintTiling,
  };

  // save min/max bounding box values for all meshes
  // scene.meshes.forEach((mesh) => {
  //   console.log(camera.isCompletelyInFrustum(mesh))
  // })

  const materialID = {};
  const color = {};
  const print = {};
  const position = {};
  const hidden = {};

  scene.meshes.forEach((mesh) => {
    if (mesh.name.startsWith("hidden")) return;

    if (!mesh.name.toLowerCase().includes("overlay")) {
      const matId = mesh.metadata?.material?.id;

      if (matId != null) {
        materialID[mesh.name] = matId;
      }
    }

    if (!mesh.metadata && mesh.isEnabled()) return;

    if (mesh.metadata?.hidden === true) {
      hidden[mesh.name] = true;
    }

    if (
      mesh.name.includes("template_Shape_") &&
      !mesh.name.startsWith("accent_")
    ) {
      position[mesh.name] = {
        x: mesh.position._x,
        z: mesh.position._z,
      };
    }

    if (
      mesh.material &&
      mesh.material.name !== "default material" &&
      mesh.material !== RH.DEFAULT_MATERIAL.standard1 &&
      mesh.material !== RH.DEFAULT_MATERIAL.standard2 &&
      mesh.metadata
    ) {
      // Added this check because it was adding empty arrays into the saved
      // JSON for meshes that have `mesh.metadata` but none of the four
      // colorX fields actually set, e.g. `"color": { "template_Shape_01": [] }`.
      if (
        mesh.metadata.colorR ||
        mesh.metadata.colorG ||
        mesh.metadata.colorB ||
        mesh.metadata.colorA
      ) {
        color[mesh.name] = [
          mesh.metadata.colorR,
          mesh.metadata.colorG,
          mesh.metadata.colorB,
          mesh.metadata.colorA,
        ].filter((value) => value && typeof value === "object");
      }

      const p = mesh.metadata.print;
      const printData = {};
      if (p != null) {
        let printID = p.egoID || p.id;
        if (p.hasOwnProperty("egoID")) {
          printID = "egoID-" + printID;
          printData.url = p.egoFileURL || p.egoImageFullURL;
        }
        if (printID) printData.id = printID;
        if (p.rotation) printData.rotation = p.rotation;
        // Moved inside the null check so a mesh whose `print` metadata
        // exists but resolved to no usable id doesn't get an empty
        // `printData` object written into the saved JSON either.
        print[mesh.name] = printData;
      }
    }
  });

  data.materialID = materialID;
  data.color = color;
  data.print = print;
  data.hidden = hidden;
  data.position = position;

  const merge = [];
  const mergedMeshesNames = Object.keys(currentMerges);
  if (mergedMeshesNames.length) {
    mergedMeshesNames.forEach((mergedMeshName) => {
      merge.push(currentMerges[mergedMeshName].join(","));
    });
  }
  data.merge = merge;

  if (isNew) {
    const lastEntry = patternHistory[historyIndex - 1];

    if (lastEntry && isPatternEqual(lastEntry, data)) {
      return data;
    }

    if (historyIndex < patternHistory.length)
      patternHistory.splice(historyIndex, patternHistory.length);

    if (patternHistory.length > 99) patternHistory.shift();
    patternHistory.push(data);
    historyIndex++;

    console.trace(
      `%c [HISTORY SAVED] %c historyIndex=${historyIndex} — total=${patternHistory.length} — data: `,
      "background: #d35400; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;",
      "background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;",
      data,
    );
  }

  // console.log('Data : ', data)

  // afterSavingPattern()
  // console.log(
  //     `%c [SERIALIZE] Output Data `,
  //     'background: #d63384; color: white; font-weight: bold; padding: 4px; border-radius: 4px;',
  //     data
  // );
  return data;
}

function afterSavingPattern() {
  RH.SavePrintRequirement();
}

/**
 *
 * @param {import('@/types/pattern.js').PatternDraft} patternData
 * @param {boolean} resetHistory
 */
export function RestorePattern(patternData, resetHistory, callback) {
  // console.log('RESTORE PATTERN : ', patternData)
  // console.log(
  //     `%c [RESTORE PATTERN] `,
  //     'background: #e17055; color: white; font-weight: bold; padding: 4px; border-radius: 4px;',
  //     patternData
  // );
  isFirstScreenshotTaken = false;
  if (isRestoring || !RH.DEFAULT_MATERIAL.nodeMaterial)
    setTimeout(RestorePattern, 100, patternData, resetHistory, callback);
  else {
    isRestoring = true;
    if (!patternData || Object.keys(patternData).length === 0) {
      isRestoring = false;
      return;
    }

    applicationMode = APPLICATION_MODES.NONE;
    // console.log('Pattern data frame : ', patternData?.frameID, ' pattern frame : ', patternData?.patternFrameID)
    scene.meshes.forEach((mesh) => {
      if (
        mesh.material &&
        patternData.print &&
        patternData.print[mesh.name] &&
        mesh.material.getTextureBlocks
      ) {
        const block = mesh.material
          .getTextureBlocks()
          .find((b) => b.name === "yPrintTex" || b.name === "yCustomPrintTex");
        if (block && block.texture) {
          block.texture.wAng = patternData.print[mesh.name].rotation || 0;
        }
      }
      if (mesh.material) {
        mesh.material.markAsDirty(BABYLON.Material.TextureDirtyFlag);
      }
    });

    const templateID = patternData.templateID;
    getTemplate(templateID)
      .then((template) => applyTemplate(template))
      .then(() => {
        const sceneID = patternData.sceneID;
        return getScene(sceneID);
      })
      .then((sceneObj) => applyScene(sceneObj))
      .then(async () => {
        // isRestoring = false
        if (resetHistory) {
          onWindowResize(scene._engine._renderingCanvas);
          patternHistory.length = 0;
          patternHistory.push(patternData);
          historyIndex = patternHistory.length;
        } else if (patternHistory.length === 0) {
          // Initialize history if empty (e.g., in preview mode)
          patternHistory.push(patternData);
          historyIndex = patternHistory.length;
        }
        await applyPatternData(patternData, true);
        if (!firstApplyPatternDone) {
          historyIndex = 0;
          firstApplyPatternDone = true;
          // console.log('REST UNDO HISTORY')
        }

        SetCanvasMode(mode);
        savePattern(true, async () => {
          await applySurfaceProperties();
          isRestoring = false;
          callback && callback();
        });
        createClippingMask();
      })
      .catch((err) => {
        isRestoring = false;
        console.log(err);
      });
  }
}

var getTemplate = function (templateID) {
  return new Promise(function (resolve, reject) {
    if (templateID == null || templateID == undefined) {
      resolve();
      return;
    }
    // Gallery templates are duplicated in PatternTemplates; also check GalleryTemplates
    let templateObj = TemplateSets.PatternTemplates.find(
      (template) => template.id == templateID,
    );
    if (!templateObj && TemplateSets.GalleryTemplates) {
      templateObj = TemplateSets.GalleryTemplates.find(
        (template) => template.id == templateID,
      );
    }
    templateObj ? resolve(templateObj) : reject("No template Found");
  });
};

var getAccent = function (accentID) {
  return new Promise(function (resolve, reject) {
    if (accentID == null || accentID == undefined) {
      resolve();
      return;
    }
    const accentObj = Assets.accents.find((accent) => accent.id == accentID);
    accentObj ? resolve(accentObj) : reject("No accent Found");
  });
};

var getFrame = function (frameID) {
  return new Promise(function (resolve, reject) {
    if (frameID == null || frameID == undefined) {
      resolve();
      return;
    }
    const frameObj = Assets.frames.find((frame) => frame.id == frameID);
    frameObj ? resolve(frameObj) : reject("No frame Found");
  });
};

var getPatternFrame = function (frameID) {
  // console.log('Frame id : ', frameID)
  return new Promise(function (resolve, reject) {
    if (frameID == null || frameID == undefined) {
      resolve();
      return;
    }
    const frameObj = Assets.patternFrames.find((frame) => frame.id == frameID);
    frameObj ? resolve(frameObj) : reject("No frame Found");
  });
};

var getScene = function (sceneID) {
  return new Promise(function (resolve, reject) {
    if (sceneID == null || sceneID == undefined) {
      resolve();
      return;
    }
    const accentObj = Assets.scenes.find((scene) => scene.id == sceneID);
    accentObj ? resolve(accentObj) : reject("No scene Found");
  });
};

var getPrint = function (printID) {
  return new Promise(function (resolve, reject) {
    function searchArray(id, arr) {
      for (let i = 0; i < arr.length; i++) {
        // Use == for type coercion to handle string/number comparison
        if (id == arr[i].egoID) {
          resolve(arr[i]);
          return true;
        }
      }
    }
    let print = null;
    if (typeof printID == "string") {
      print = printID.split("-");
      if (print[0] === "egoID") {
        if (searchArray(print[1], Uploads)) return;

        const data = {
          format: "json",
          egoID: print[1],
          requestType: "egoLoad",
        };
        axios.post("/ajax/objects", qs.stringify(data)).then((res) => {
          res.data.isError
            ? reject("Ego Item not found")
            : resolve(res.data.egoObjects);
        });
        return;
      }
    }

    let printItem = null;
    printItem = Assets.prints.standard.find(
      (printItem) => printItem.id == printID,
    );
    printItem ? resolve(printItem) : reject("Print not found");
  });
};

var getMaterial = function (matID) {
  return new Promise(function (resolve, reject) {
    const material = Assets.materials.find((mat) => mat.id == matID);
    material ? resolve(material) : reject("Material not found");
  });
};

function readAndApplyColor(colorData, mesh) {
  if (!colorData || !Array.isArray(colorData) || colorData.length === 0) {
    const hasExistingColor =
      mesh.metadata &&
      (mesh.metadata.hasOwnProperty("colorR") ||
        mesh.metadata.hasOwnProperty("color") ||
        (Array.isArray(mesh.metadata.color) && mesh.metadata.color.length > 0));

    if (hasExistingColor) {
      try {
        unsetColor(mesh);
      } catch (e) {
        console.warn("Failed to unset color safely:", e);
      }
    }
    return false;
  }

  delete mesh.metadata.colorR;
  if (colorData && Array.isArray(colorData) && colorData.length > 0) {
    const hexColors = colorData.map(({ r, g, b }) =>
      new BABYLON.Color3(r, g, b).toHexString(),
    );

    // Applying colors to the mesh if needed (optional)
    // hexColors.forEach((hexColor) => applyColor(mesh, hexColor));

    applyColorArray(mesh, hexColors, true);
    // console.log('Hex Colors:', hexColors);

    return true;
  } else if (mesh.metadata.print) {
    applyColorFromPrint(mesh, mesh.metadata.print);
    return false;
  } else {
    mesh.material &&
      mesh.material.getClassName() === "NodeMaterial" &&
      RH.ApplyDefaultColor(mesh.material);
    return false;
  }
}

function applyPrintAndColor(mesh, print, colorData) {
  applyPrint(mesh, print);
  if (colorData) readAndApplyColor(colorData, mesh);
}

function generateMergedMeshName(firstMeshName) {
  // const lowerName = firstMeshName.toLowerCase();
  //
  // if (lowerName.startsWith('template_')) {
  //   return 'template_' + firstMeshName.substring(9) + '_Merge';
  // } else if (lowerName.startsWith('accent_')) {
  //   return 'accent_' + firstMeshName.substring(7) + '_Merge';
  // } else {
  //   return firstMeshName + '_Merge';
  // }
  return firstMeshName + "_Merge";
}

function applyMerges() {
  const mergedMeshNames = [];
  const patternData = patternHistory[historyIndex - 1];
  if (!patternData) return;

  if (patternData.merge) {
    for (let i = 0; i < patternData.merge.length; i++) {
      const mergeOf = patternData.merge[i].split(",");
      const firstMeshName = mergeOf[0];

      const mergedMeshName = generateMergedMeshName(firstMeshName);

      if (
        !currentMerges[mergedMeshName] ||
        currentMerges[mergedMeshName].join(",") !== patternData.merge[i]
      ) {
        disposeMerge(mergedMeshName);

        let hasValidMeshes = false;
        mergeOf.forEach((meshName) => {
          let mesh = scene.getMeshByName(meshName);
          if (mesh) {
            if (mesh.isAnInstance) {
              mesh = shatterInstance(mesh);
            }

            meshesSelectedForMerging.add(mesh);
            hasValidMeshes = true;
          }
        });

        if (hasValidMeshes) {
          mergeSelectedMeshes(true);
        }
      }
      mergedMeshNames.push(mergedMeshName);
    }
  }

  Object.keys(currentMerges).forEach((mergedMeshName) => {
    if (mergedMeshNames.indexOf(mergedMeshName) == -1) {
      disposeMerge(mergedMeshName);
    } else {
    }
  });

  RH.UpdateTemplateOutline();
}

function areSavedStylesDifferent(instanceName, masterName, patternData) {
  const getVal = (obj, key) => (obj ? obj[key] : undefined);

  const diverges = (instVal, masterVal) => {
    if (instVal === undefined || instVal === null) return false;
    if (JSON.stringify(instVal) === JSON.stringify(masterVal)) return false;
    return true;
  };

  // const logDivergence = (propName, instVal, masterVal) => {
  //   console.log(
  //       `%c [DIVERGENCE DETECTED] %c ${instanceName} differs from ${masterName} in ${propName} \n Instance: %O \n Master: %O `,
  //       'background: #f39c12; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;',
  //       'background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;',
  //       instVal,
  //       masterVal
  //   );
  // };

  const instMat = getVal(patternData.materialID, instanceName);
  const masterMat = getVal(patternData.materialID, masterName);
  if (diverges(instMat, masterMat)) {
    // logDivergence('Material ID', instMat, masterMat);
    return true;
  }

  const instPrintObj = getVal(patternData.print, instanceName);
  const masterPrintObj = getVal(patternData.print, masterName);
  const instPrint = instPrintObj ? instPrintObj.id : null;
  const masterPrint = masterPrintObj ? masterPrintObj.id : null;
  if (diverges(instPrint, masterPrint)) {
    // logDivergence('Print ID', instPrint, masterPrint);
    return true;
  }

  const instColor = getVal(patternData.color, instanceName);
  const masterColor = getVal(patternData.color, masterName);
  if (diverges(instColor, masterColor)) {
    // logDivergence('Color', instColor, masterColor);
    return true;
  }

  return false;
}

async function applySurfaceProperties() {
  sharedMaterial = null;
  sharedFrom = null;
  const patternData = patternHistory[historyIndex - 1];

  if (!patternData) return;

  const meshesToProcess = [...scene.meshes];

  for (const currentMesh of meshesToProcess) {
    if (!currentMesh.metadata || currentMesh.name.startsWith("hidden_"))
      continue;

    let mesh = currentMesh;
    let dataKey = mesh.name;

    if (mesh.isAnInstance) {
      const masterName = mesh.sourceMesh.name;
      const isDifferent = areSavedStylesDifferent(
        mesh.name,
        masterName,
        patternData,
      );

      if (isDifferent) {
        mesh = shatterInstance(mesh, false);
      } else {
        continue;
      }
    }

    const targetMaterialID = patternData.materialID
      ? patternData.materialID[mesh.name]
      : null;
    const printData = (patternData.print || {})[mesh.name];
    const colorData = (patternData.color || {})[mesh.name];

    const hasMaterial =
      targetMaterialID !== null && targetMaterialID !== undefined;
    const hasPrint = printData && printData.id !== undefined;
    const hasColor = colorData !== undefined;

    mesh.material = RH.GetMeshMaterial(mesh);

    if (hasMaterial) {
      if (
        !mesh.metadata.material ||
        targetMaterialID != mesh.metadata.material.id
      ) {
        // A failed getMaterial() fetch (e.g. transient network error while
        // restoring a saved pattern) used to throw out of this whole restore
        // pass, leaving every mesh after this one in the loop un-restored.
        // Fall back to whatever default material the mesh already has so
        // one bad material lookup can't take down the rest of the load.
        try {
          const material = await getMaterial(targetMaterialID);
          applyMaterial(mesh, material);
        } catch (error) {
          // NOTE: the upstream fix referenced a bare `defaultMaterial.standard1`
          // here, which isn't in scope in this file (only `RH.DEFAULT_MATERIAL`
          // is) and would have thrown a ReferenceError on the very fallback
          // path meant to prevent a crash. Using the correct RH-qualified ref.
          mesh.material =
            mesh.metadata.defaultMaterial || RH.DEFAULT_MATERIAL.standard1;
        }
      }
    } else {
      if (!mesh.name.startsWith("scene") && !mesh.name.startsWith("frame")) {
        unsetMaterial(mesh);
      }
    }
    if (hasPrint) {
      const id = printData.id;
      const possibleEgoID = String(id).split("-")[1];

      if (
        mesh.metadata.print &&
        ((mesh.metadata.print.egoID &&
          mesh.metadata.print.egoID == possibleEgoID) ||
          (!mesh.metadata.print.egoID && mesh.metadata.print.id == id))
      ) {
        readAndApplyColor(colorData, mesh);
      } else if (possibleEgoID) {
        applyPrintAndColor(
          mesh,
          {
            egoID: possibleEgoID,
            egoFileURL: printData.url,
            rotation: printData.rotation || 0,
          },
          colorData,
        );
      } else {
        try {
          const print = await getPrint(id);
          applyPrintAndColor(
            mesh,
            {
              ...print,
              rotation: printData.rotation || 0,
            },
            colorData,
          );
        } catch (err) {
          console.warn(`Failed to apply print ${id} to ${mesh.name}:`, err);
        }
      }
    } else {
      if (!mesh.name.startsWith("scene")) {
        if (!mesh.name.startsWith("frame")) unsetPrint(mesh);

        readAndApplyColor(colorData, mesh);
      }
    }
  }
}

// function applyBoarders() {
//   const patternData = patternHistory[historyIndex - 1]
//
//   if (!patternData?.boarder) {
//     return
//   }
//
//   patternProps.boarderType = patternData.boarder?.type || 'square'
//   patternProps.boarderWidth = patternData.boarder?.width || 0
//   updateBoarder()
// }

function applyMattings() {
  const patternData = patternHistory[historyIndex - 1];

  if (!patternData?.matting) {
    return;
  }
  patternProps.mattingWidth = patternData.matting?.width || 0;
  updateMatting();
}

function applyPositions() {
  const patternData = patternHistory[historyIndex - 1];
  // Safety check: skip if no pattern data available (e.g., in preview mode)
  if (!patternData) {
    return;
  }
  scene.meshes.forEach(async (mesh) => {
    const position = (patternData.position || {})[mesh.name];
    if (position) {
      mesh.position.x = position.x || 0;
      mesh.position.z = position.z || 0;
    }
  });
  scene.render();
}

function applyHiddenMeshes() {
  const patternData = patternHistory[historyIndex - 1];
  const hiddenData = patternData.hidden ?? {};

  scene.meshes.forEach((mesh) => {
    const shouldBeHidden = hiddenData[mesh.name] === true;

    if (mesh.metadata) {
      mesh.metadata.hidden = shouldBeHidden;
    }

    if (mesh.name.startsWith("accent")) {
      if (shouldBeHidden) {
        let targetMesh = mesh;

        // if (targetMesh.isAnInstance) {
        //   console.log(`[HIDE TOOL] Shattering instance ${targetMesh.name} to hide it safely.`);
        //   targetMesh = shatterInstance(targetMesh);
        //
        //   if (targetMesh.metadata) targetMesh.metadata.hidden = true;
        // }

        targetMesh.setEnabled(false);
      }
      // else {
      //   mesh.setEnabled(true);
      // }
    }
  });
  // scene.render()
}

var addPatternData = function (patternData) {
  // patternHistory.push(patternData)
  // historyIndex++
};
/**
 * @param {import('@/types/pattern.js').PatternDraft} patternData
 */
var applyPatternData = async function (
  patternData,
  boarderShouldBeUpdated = false,
) {
  // addPatternData(patternData)
  console.log(
    `%c [PATTERN] Applying Pattern Data `,
    "background: #0984e3; color: white; font-weight: bold; padding: 4px; border-radius: 4px;",
    patternData,
  );

  applyPatternFinished = false;

  applyPositions();

  // if (
  //   patternProps.boarderType !== patternData.boarder?.type ||
  //   patternProps.boarderWidth !== patternData.boarder?.width ||
  //   boarderShouldBeUpdated
  // ) {
  //   applyBoarders()
  // }

  if (
    patternProps.mattingWidth !== patternData.matting?.width ||
    boarderShouldBeUpdated
  ) {
    applyMattings();
  }

  await applyAccent(patternData.accentID);
  updateSliderFromAccentScale(patternData.accentScale);
  updateSliderFromAccentNumber(patternData.accentNumber);
  updateSliderFromAccentRotation(patternData.accentRotation);
  updateSliderFromPrintTiling(patternData.printTiling);

  if (patternData.accentScale) SetAccentScale(patternData.accentScale * 100);
  else SetAccentScale(100);

  if (patternData.accentNumber) SetAccentNumber(patternData.accentNumber);
  else SetAccentNumber(1);

  if (patternData.accentRotation) SetAccentRotation(patternData.accentRotation);
  else SetAccentRotation(0);

  // prefillInstanceMetadata(patternData);

  if (patternData.frameID && (topicType === "gallery" || topicType === null)) {
    await applyGalleryFrame(patternData.frameID);
  }

  if (patternData.frameID && (topicType === "pattern" || topicType === null)) {
    await applyPatternFrame(patternData.frameID);
  }

  patternProps.currentPrintTiling = 1;
  if (patternData.printTiling) {
    SetPrintTiling(patternData.printTiling);
  }

  applyMerges();
  applyHiddenMeshes();
  await applySurfaceProperties();
  syncInstancesToMaster();
  applyPatternFinished = true;

  // showAllHiddenMeshesHighlight()
  onPatternRestore(patternProps);

  // console.log(
  //     `%c [PATTERN] Apply Pattern Finished `,
  //     'background: #00b894; color: black; font-weight: bold; padding: 4px; border-radius: 4px;'
  // );
};

function syncInstancesToMaster() {
  scene.meshes.forEach((mesh) => {
    if (mesh.isAnInstance && mesh.sourceMesh && mesh.sourceMesh.metadata) {
      const sourceMeta = mesh.sourceMesh.metadata;

      if (!mesh.metadata) mesh.metadata = {};

      mesh.metadata.colorR = sourceMeta.colorR;
      mesh.metadata.colorG = sourceMeta.colorG;
      mesh.metadata.colorB = sourceMeta.colorB;
      mesh.metadata.colorA = sourceMeta.colorA;

      if (sourceMeta.print) {
        mesh.metadata.print = JSON.parse(JSON.stringify(sourceMeta.print));
      } else {
        delete mesh.metadata.print;
      }

      mesh.metadata.material = sourceMeta.material;
    }
  });
}

/**
 *
 * @param {{url: string, name: string}} template
 */
function clearSceneMeshes() {
  const meshesToRemove = scene.meshes.filter((mesh) =>
    mesh.name.startsWith("Scene"),
  );

  meshesToRemove.forEach((mesh) => {
    scene.removeMesh(mesh);
  });

  const lightsToRemove = scene.lights.slice();
  lightsToRemove.forEach((light) => {
    light.dispose();
  });
}

function applyTemplate(template) {
  return new Promise(function (resolve, reject) {
    // Validate template object
    if (!template) {
      console.error("❌ Template is null or undefined");
      reject("Template is null or undefined");
      return;
    }
    if (!template.url) {
      console.error("❌ Template URL is missing:", template);
      reject("Template URL is missing");
      return;
    }

    function changeTemplate() {
      isTemplateLoading = true;

      if (
        patternProps.currentTemplate &&
        template.id == patternProps.currentTemplate.id
      ) {
        isTemplateLoading = false;
        resolve(false);
      } else {
        const pathArr = template.url.split("/");
        const fileName = pathArr.pop();
        // if(topicType == 'gallery')
        // {
        clearSceneMeshes();
        // }
        RH.ClearScene(["template", "boarder", "accent", "frame"]);

        clearAccentParent();
        patternProps.currentTemplate = template;
        patternProps.currentAccentID = null;
        patternProps.currentFrameID = null;
        // patternProps.currentPatternFrameID = null
        patternProps.mattingWidth = 0;

        if (patternProps.currentTemplate.radius) {
          // && (topicType=="quilt") )
          camera.radius = patternProps.currentTemplate.radius;
        } else camera.radius = 2;

        if (patternProps.currentTemplate.radiusMax) {
          camera.upperRadiusLimit = patternProps.currentTemplate.radiusMax;
        }

        const initialMeshes = new Set(scene.meshes);
        const fullPath = STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/";
        console.log("🎯 Loading template:", {
          template: template,
          url: template.url,
          pathArr: pathArr,
          fileName: fileName,
          fullPath: fullPath,
          finalURL: fullPath + fileName,
        });

        if (!fileName || fileName === "undefined") {
          console.error(
            "❌ Invalid template filename:",
            fileName,
            "from URL:",
            template?.url,
          );
          isTemplateLoading = false;
          reject("Invalid template filename");
          return;
        }

        // Test if file is accessible
        fetch(fullPath + fileName)
          .then((response) => {
            console.log("📡 File accessibility check:", {
              url: fullPath + fileName,
              status: response.status,
              statusText: response.statusText,
              ok: response.ok,
              headers: {
                contentType: response.headers.get("content-type"),
                contentLength: response.headers.get("content-length"),
              },
            });
            if (!response.ok) {
              throw new Error(
                `HTTP ${response.status}: ${response.statusText}`,
              );
            }
          })
          .catch((err) => {
            console.error("❌ File not accessible:", err);
          });

        BABYLON.SceneLoader.Append(
          fullPath,
          fileName,
          scene,
          (loadedScene) => {
            console.log("✅ Babylon SceneLoader success callback called");
            console.log("Loaded scene:", loadedScene);
            const newMeshes = scene.meshes.filter(
              (mesh) => !Array.from(initialMeshes).includes(mesh),
            );

            const importedLights = loadedScene.lights;

            const importedLightsCount = importedLights.length;

            console.log("Light imported : ", importedLightsCount);
            if (importedLightsCount <= 0) {
              // console.log(`Imported ${importedLightsCount} light(s).`);
              // light.setEnabled(false);
              createLights();
            }

            const templateMerges = Object.keys(currentMerges);
            for (let i = 0; i < templateMerges.length; i++) {
              if (/^template_/.test(templateMerges[i])) {
                delete currentMerges[templateMerges[i]];
              }
            }
            meshesSelectedForMerging.clear();
            RH.ShowHighlightOn(meshesSelectedForMerging);
            // RH.ShowHighlightForSource(null, false)
            scene.render();
            // loadedAssets.meshes.forEach((mesh) => mesh.dispose());

            engine.hideLoadingUI();

            newMeshes.forEach((mesh) => {
              if (mesh.name.startsWith("Scene")) {
                if (mesh.material) {
                  mesh.material.needDepthPrePass = true;
                }
              }
            });

            RH.ProcessMeshes(newMeshes, `template`, (mesh) => {});

            let needAssetsUpdate = false;
            if (!patternProps.currentTemplate.tiling) {
              const bb = loadedScene.meshes
                .find((mesh) => !mesh.name.toLowerCase().includes("overlay"))
                .getBoundingInfo().boundingBox;
              patternProps.currentTemplate.tiling = Math.max(
                bb.extendSizeWorld.z,
                bb.extendSizeWorld.x,
              );
              needAssetsUpdate = true;
            }

            const number = parseInt(
              patternProps.currentTemplate.name.split("x")[0],
            );
            let offset = 0;

            if (topicType == "quilt") {
              if (!isNaN(number)) offset = number % 2 === 0 ? 0 : 0.5;
            } else {
              offset = 0.5;
            }

            patternProps.currentTemplate.vOffset =
              patternProps.currentTemplate.uOffset = offset;
            needAssetsUpdate = true;
            outlineNeedsUpdate = true;
            scene.meshes.forEach((mesh) => {
              if (
                mesh.name.startsWith("accent_") &&
                !mesh.name.toLowerCase().includes("overlay")
              ) {
                const printObj = mesh.metadata.print;
                if (mesh.metadata.print) {
                  delete mesh.metadata.print;
                  applyPrint(mesh, printObj);
                }
              }
            });
            RH.ComputeBoundsOfPattern();
            isTemplateLoading = false;
            resolve(true);
            needAssetsUpdate && onAssetsUpdate(Assets);

            templateMeshesCache = newMeshes.filter((mesh) =>
              mesh.name.startsWith("template"),
            );
            templateMeshesCache.forEach((mesh) => mesh.freezeWorldMatrix());

            // if(topicType=='gallery')
            // {
            //   adjustCameraToFitMeshes()
            // }
            calculateCameraHorizontalBounds();
            SetCameraHorizontalPosition(0.5);
            updateSliderFromCameraHorizontalPosition(0.5);

            updateSliderFromAccentScale(1);
            updateSliderFromAccentNumber(1);
            updateSliderFromAccentRotation(0);
            updateSliderFromPrintTiling(1);
            createClippingMask();
          },
          (event) => {
            // onProgress callback - this was being mistaken for error handler!
            console.log("📊 Loading progress:", event);
          },
          (scene, message, exception) => {
            // This is the actual onError callback (5th parameter)
            console.error(
              "❌ ERROR callback - actual error loading Babylon asset:",
              {
                fullPath: fullPath + fileName,
                message: message || "No message provided",
                exception: exception || "No exception provided",
                template: template,
                fileName: fileName,
                pathArr: pathArr,
              },
            );
            isTemplateLoading = false;
            reject(exception || message || "Failed to load template");
          },
        );

        // BABYLON.SceneLoader.ImportMesh(
        //   null,
        //   STATIC_ASSETS_DIRECTORY + pathArr.join('/') + '/',
        //   fileName,
        //   scene,
        //   (meshes) => {
        //
        //     const templateMerges = Object.keys(currentMerges)
        //     for (let i = 0; i < templateMerges.length; i++) {
        //       if (/^template_/.test(templateMerges[i])) {
        //         delete currentMerges[templateMerges[i]]
        //       }
        //     }
        //     meshesSelectedForMerging.clear()
        //     RH.ShowHighlightOn(meshesSelectedForMerging)
        //     scene.render()
        //
        //     RH.ProcessMeshes(meshes, `template`, (mesh) => {
        //       /* comment this movement for now
        //       if (topicType === 'gallery' && !OVERLAY_TEST_REGEX.test(mesh.name)) {
        //         const pointerDragBehavior = new BABYLON.PointerDragBehavior({
        //           dragPlaneNormal: new BABYLON.Vector3(0, 0, 0),
        //         })
        //
        //         pointerDragBehavior.onDragStartObservable.add((event) => {})
        //         pointerDragBehavior.onDragObservable.add((event) => {
        //           // reset asset item status to prevent double saving in patternHistory after ending drag
        //           currentItem = null
        //           applicationMode = APPLICATION_MODES.NONE
        //
        //           const shapeIndex = mesh.name.split('_')[2]
        //           scene.meshes.forEach((i) => {
        //             let boarderRegex = new RegExp('^boarder_Shape_' + shapeIndex)
        //             let accentRegex = new RegExp('Shape_' + shapeIndex + '_accent')
        //             let frameRegex = new RegExp('^frame_Shape_'+shapeIndex)
        //             let mattingRegex = new RegExp('^matting_Shape_'+shapeIndex)
        //
        //             if (boarderRegex.test(i.name)) {
        //               i.position.x += event.delta._x
        //               i.position.z += event.delta._z
        //             }
        //             if (accentRegex.test(i.name)) {
        //               const ps =
        //                 mesh.metadata.accentID === 4 ? 1 : pScale[patternProps.currentTemplate.id]
        //               const ms =
        //                 mesh.metadata.accentID === 4 ? 1 : mScale[patternProps.currentTemplate.id]
        //               i.position.x += event.delta._x * ps * ms
        //               i.position.z += event.delta._z * ps * ms
        //             }
        //
        //             if(frameRegex.test(i.name))
        //             {
        //               i.position.x += event.delta._x
        //               i.position.z += event.delta._z
        //             }
        //
        //             if(mattingRegex.test(i.name))
        //             {
        //               i.position.x += event.delta._x
        //               i.position.z += event.delta._z
        //             }
        //           })
        //         })
        //         pointerDragBehavior.onDragEndObservable.add(async (event) => {
        //           if (!currentItem) savePattern(true)
        //         })
        //         pointerDragBehavior.attach(mesh)
        //         mesh.addBehavior(pointerDragBehavior)
        //       } */
        //     })
        //     let needAssetsUpdate = false
        //     if (!patternProps.currentTemplate.tiling) {
        //       const bb = meshes
        //         .find((mesh) => !OVERLAY_TEST_REGEX.test(mesh.name))
        //         .getBoundingInfo().boundingBox
        //       patternProps.currentTemplate.tiling = Math.max(
        //         bb.extendSizeWorld.z,
        //         bb.extendSizeWorld.x,
        //       )
        //       // console.log(`Template tiling : ${patternProps.currentTemplate.tiling}, zworld : ${bb.extendSizeWorld.z}, xWorld :${bb.extendSizeWorld.x}`)
        //       needAssetsUpdate = true
        //     }
        //     // else
        //     // {
        //     //   console.log(`Found tiling : ${patternProps.currentTemplate.tiling}`)
        //     // }
        //     // console.log(`template name : ${patternProps.currentTemplate.name}, topidType : ${topicType}`)
        //     // if (!patternProps.currentTemplate.hasOwnProperty('uOffset')) {
        //       const number = parseInt(patternProps.currentTemplate.name.split('x')[0])
        //       let offset = 0
        //
        //       if(topicType=="quilt") {
        //         if (!isNaN(number)) offset = number % 2 === 0 ? 0 : 0.5
        //       }
        //       else {
        //         offset = 0.5
        //       }
        //
        //       // console.log(`Pattern : ${patternProps.currentTemplate.name}, offset : ${offset}, number : ${number}`);
        //       patternProps.currentTemplate.vOffset = patternProps.currentTemplate.uOffset = offset
        //       needAssetsUpdate = true
        //     // }
        //     outlineNeedsUpdate = true
        //     scene.meshes.forEach((mesh) => {
        //       //this so that offsets and scales are updated on accents
        //       if (/^accent_/.test(mesh.name) && !OVERLAY_TEST_REGEX.test(mesh.name)) {
        //         const printObj = mesh.metadata.print
        //         if (mesh.metadata.print) {
        //           delete mesh.metadata.print
        //           applyPrint(mesh, printObj)
        //         }
        //       }
        //     })
        //     RH.ComputeBoundsOfPattern()
        //     isTemplateLoading = false
        //     resolve(true)
        //     needAssetsUpdate && onAssetsUpdate(Assets)
        //
        //     if(topicType=='gallery')
        //     {
        //       adjustCameraToFitMeshes()
        //     }
        //     calculateCameraHorizontalBounds()
        //     SetCameraHorizontalPosition(0.5)
        //     updateSliderFromCameraHorizontalPosition(0.5)
        //
        //   },
        //   null,
        //   (scene, message, e) => {
        //     isTemplateLoading = false
        //     reject(message, e)
        //   },
        // )
      }

      // resetScreenshot()
    }

    function queueChecker() {
      setTimeout(() => {
        isTemplateLoading ? queueChecker() : changeTemplate();
      }, 100);
    }
    if (template) queueChecker();
    else {
      RH.ClearScene(["template"]);
      resolve(false);
    }
  });
}

function calculateCameraHorizontalBounds() {
  let minX = Infinity;
  let maxX = -Infinity;

  // scene.meshes.forEach((mesh) => {
  //   if (mesh.name.startsWith('template')) {
  //     const boundingBox = mesh.getBoundingInfo().boundingBox
  //
  //     minX = Math.min(minX, boundingBox.minimumWorld.x)
  //     maxX = Math.max(maxX, boundingBox.maximumWorld.x)
  //   }
  // })

  templateMeshesCache.forEach((mesh) => {
    const boundingBox = mesh.getBoundingInfo().boundingBox;

    minX = Math.min(minX, boundingBox.minimumWorld.x);
    maxX = Math.max(maxX, boundingBox.maximumWorld.x);
  });

  if (minX != Infinity) minCameraHorizontalBounds = maxX;

  if (maxX != -Infinity) maxCameraHorizontalBounds = minX;
}

function adjustCameraToFitMeshes() {
  let minX = Infinity,
    minZ = Infinity;
  let maxX = -Infinity,
    maxZ = -Infinity;
  let aspectRatio = 1 / 1.5;

  scene.meshes.forEach((mesh) => {
    if (!mesh.name.startsWith("Scene") && !mesh.name.startsWith("Light")) {
      if (mesh.getBoundingInfo) {
        const boundingInfo = mesh.getBoundingInfo().boundingBox;

        minX = Math.min(minX, boundingInfo.minimumWorld.x);
        minZ = Math.min(minZ, boundingInfo.minimumWorld.z);

        maxX = Math.max(maxX, boundingInfo.maximumWorld.x);
        maxZ = Math.max(maxZ, boundingInfo.maximumWorld.z);
      }
    }
  });

  const sizeX = maxX - minX;
  const sizeZ = maxZ - minZ;

  const adjustedSizeX = sizeX * aspectRatio;
  const adjustedSizeZ = sizeZ;

  const maxDimension = Math.max(adjustedSizeX, adjustedSizeZ);

  const distanceToFit = maxDimension * 1.5;

  if (camera instanceof BABYLON.ArcRotateCamera) {
    camera.radius = distanceToFit;
  }
}

function applyAccentForMesh(mesh, accentData, clicked = false) {
  return new Promise(function (resolve, reject) {
    RH.EmptySceneOfMeshes(`${mesh.name}_accent`);
    if (!accentData.id || isAccentLoading) resolve(false);
    else if (mesh.metadata.accentID === accentData.id && clicked) {
      mesh.metadata.accentID = null;
      resolve(false);
    } else {
      const accentParent = new BABYLON.TransformNode(
        `${mesh.name}_accent_parent`,
        scene,
      );

      // apply accent to mesh
      isAccentLoading = true;
      const pathArr = accentData.url.split("/");
      const fileName = pathArr.pop();
      BABYLON.SceneLoader.ImportMesh(
        null,
        STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/",
        fileName,
        scene,
        (meshes) => {
          const ps =
            accentData.id === 4 ? 1 : pScale[patternProps.currentTemplate.id];
          const ms =
            accentData.id === 4 ? 1 : mScale[patternProps.currentTemplate.id];
          const box = mesh.getBoundingInfo().boundingBox;
          const cx = (box.maximumWorld.x + box.minimumWorld.x) / 2;
          const cz = (box.maximumWorld.z + box.minimumWorld.z) / 2;
          const scale = Math.sqrt(
            1 / Math.round(1 / (box.maximumWorld.z - box.minimumWorld.z)),
            2,
          );
          RH.ProcessMeshes(
            meshes,
            `${mesh.name}_accent_${accentData.id}`,
            (m) => {
              m.position.y = mesh.position._y + 0.01;
              m.position.x = cx * ps * ms;
              m.position.z = cz * ps * ms;
              m.scaling.x = accentData.id === 4 ? scale / 2 : scale;
              m.scaling.y = 1;
              m.scaling.z = accentData.id === 4 ? scale / 2 : scale;
              m.renderingGroupId = 1;

              m.parent = accentParent;
            },
          );

          isAccentLoading = false;
          mesh.metadata.accentID = accentData.id;
          mesh.metadata.accentScale = 1;
          resolve(true);
          window.requestAnimationFrame(() => (outlineNeedsUpdate = true));
        },
        null,
        (err) => {
          console.log(err);
          isAccentLoading = false;
          reject(err);
        },
      );
    }
  });
}

function clearAccentParent() {
  if (previousAccentParents.length > 0) {
    previousAccentParents.forEach((parent) => {
      parent.dispose();
    });

    previousAccentParents = [];
  }

  toggleSliderVisibility(false);
}

async function applySingleAccent(accentID) {
  return new Promise(function (resolve, reject) {
    isAccentLoading = true;
    patternProps.currentAccentID = accentID;
    patternProps.currentAccentScale = 1;
    patternProps.currentAccentNumber = 1;
    patternProps.currentAccentRotation = 0.001;
    individualAccentScale = 1;

    let accentScale = 1;
    if (patternProps.currentTemplate.accentScale)
      accentScale = patternProps.currentTemplate.accentScale;

    RH.ClearScene(["accent"]);
    RH.SafelyDisposeMaterials();

    getAccent(accentID).then((accent) => {
      if (!accent) {
        resolve(true);
        toggleSliderVisibility(false);
        return;
      }
      const pathArr = accent.url.split("/");
      const fileName = pathArr.pop();
      patternProps.currentAccentID = accent.id;
      RH.ClearScene(["accent"]);

      clearAccentParent();

      const accentParent = new BABYLON.TransformNode("accent_parent", scene);

      Object.keys(currentMerges).forEach((key) => {
        if (key.startsWith("accent_")) delete currentMerges[key];
      });

      toggleSliderVisibility(true);
      updateSliderFromAccentScale(accentParent.scaling.x);
      updateSliderFromAccentNumber(1);
      updateSliderFromAccentRotation(patternProps.currentAccentRotation);
      updateSliderFromPrintTiling(patternProps.currentPrintTiling);

      // previousAccentParent = accentParent;
      previousAccentParents.push(accentParent);
      BABYLON.SceneLoader.ImportMesh(
        null,
        STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/",
        fileName,
        scene,
        (meshes) => {
          RH.ProcessMeshes(meshes, "accent", (mesh) => {
            mesh.position.y += 0.001;
            mesh.parent = accentParent;
            mesh.scaling = new BABYLON.Vector3(accentScale, 1, accentScale);
            mesh.renderingGroupId = 1;
          });

          isAccentLoading = false;
          window.requestAnimationFrame(() => (outlineNeedsUpdate = true));
          resolve(true);
        },
        null,
        (err) => {
          console.log(err);
          isAccentLoading = false;
          reject(err);
        },
      );
    });
  });
}

function collectInitialAccentUVs(accentParent) {
  initialAccentUVs = [];
  accentParent.getChildren().forEach((child) => {
    if (child instanceof BABYLON.Mesh) {
      const positionData = child.getVerticesData(
        BABYLON.VertexBuffer.PositionKind,
      );
      if (positionData) {
        initialAccentUVs.push({
          meshName: child.name,
          positionData: [...positionData],
        });
        // console.log(`Mesh: ${child.name}, Position Data:`, positionData);
      }
    }
  });
}

async function applyPatternFrame(frameID) {
  return new Promise(function (resolve, reject) {
    isFrameLoading = true;
    isFirstScreenshotTaken = false;
    patternProps.currentFrameID = frameID;
    // console.log('Current frame id from pattern frame : ', patternProps.currentFrameID, ' frame id : ', frameID)
    RH.ClearScene(["frame"]);

    if (!frameID) {
      patternProps.mattingWidth = 0;
      updateMatting();
      onPatternRestore(patternProps);
    }

    // const templateMeshes = scene.meshes.filter((mesh) => mesh.name.startsWith('template'))
    getPatternFrame(frameID)
      .then((frame) => {
        if (!frame) {
          resolve(true);
          return;
        }
        const pathArr = frame.url.split("/");
        const fileName = pathArr.pop();
        RH.ClearScene(["frame"]);

        framePartMeshes = [];
        BABYLON.SceneLoader.ImportMesh(
          null,
          STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/",
          fileName,
          scene,
          (meshes) => {
            // const templateMeshes = scene.meshes.filter((mesh) => mesh.name.startsWith('template'))
            const templateMeshes = templateMeshesCache;
            if (templateMeshes.length === 0) {
              console.warn("No template meshes found");
              resolve(false);
              return;
            }

            let minX = Infinity,
              minY = Infinity,
              minZ = Infinity;
            let maxX = -Infinity,
              maxY = -Infinity,
              maxZ = -Infinity;

            templateMeshes.forEach((mesh) => {
              const boundingInfo = mesh.getBoundingInfo();
              const boundingBox = boundingInfo.boundingBox;

              minX = Math.min(minX, boundingBox.minimumWorld.x);
              minY = Math.min(minY, boundingBox.minimumWorld.y);
              minZ = Math.min(minZ, boundingBox.minimumWorld.z);

              maxX = Math.max(maxX, boundingBox.maximumWorld.x);
              maxY = Math.max(maxY, boundingBox.maximumWorld.y);
              maxZ = Math.max(maxZ, boundingBox.maximumWorld.z);
            });

            const centerX = (minX + maxX) / 2;
            const centerZ = (minZ + maxZ) / 2;

            const width = maxX - minX;
            const height = maxZ - minZ;

            frameOriginalScale = new BABYLON.Vector3(width, 1, height);

            frameOriginalPositions = {
              Frame_Back: { x: centerX, z: centerZ, y: minY - 0.1 },
              Frame_CornerBL: { x: maxX, z: maxZ },
              Frame_CornerBR: { x: minX, z: maxZ },
              Frame_CornerTL: { x: maxX, z: minZ },
              Frame_CornerTR: { x: minX, z: minZ },
              Frame_SideB: { x: centerX, z: maxZ },
              Frame_SideL: { x: maxX, z: centerZ },
              Frame_SideR: { x: minX, z: centerZ },
              Frame_SideT: { x: centerX, z: minZ },
            };

            meshes.forEach((mesh) => {
              const frameName = patternFrameNames.find((frame) =>
                mesh.name.includes(frame.name),
              );

              if (frameName) {
                const position = frameOriginalPositions[frameName.name];
                mesh.position.x = position.x;
                mesh.position.z = position.z;

                if (position.y !== undefined) {
                  mesh.position.y = position.y;
                }

                if (
                  frameName.name === "Frame_SideT" ||
                  frameName.name === "Frame_SideB"
                ) {
                  frameOriginalMaterial = mesh.material;
                  mesh.scaling.x = width;
                } else if (
                  frameName.name === "Frame_SideL" ||
                  frameName.name === "Frame_SideR"
                ) {
                  mesh.scaling.z = height;
                }

                framePartMeshes.push(mesh);
                RH.ProcessMesh(mesh, "frame", frameName.name);
              } else {
                console.warn(`Unknown frame part: ${mesh.name}`);
              }
            });

            adjustPatternFrameScale();
            isFrameLoading = false;
            window.requestAnimationFrame(() => (outlineNeedsUpdate = true));
            resolve(true);
            if (!isFirstScreenshotTaken) {
              resetScreenshot();
              isFirstScreenshotTaken = true;
            }
          },
          null,
          (err) => {
            console.log(err);
            isFrameLoading = false;

            reject(err);
          },
        );
      })
      .catch((err) => {
        // getPatternFrame() rejects when frameID doesn't match anything in
        // the pattern-frame catalog. Without this, the promise applyPatternData
        // `await`s would hang forever on a stale/unknown saved frameID,
        // silently blocking the onPatternRestore() call the UI's selection
        // chips sync from. Resolve instead, same as the "no frame found"
        // (`!frame`) path above.
        console.warn(
          "applyPatternFrame: frame lookup failed, continuing without one",
          frameID,
          err,
        );
        isFrameLoading = false;
        resolve(true);
      });
  });
}

async function applyGalleryFrame(frameID) {
  return new Promise(function (resolve, reject) {
    isFrameLoading = true;
    patternProps.currentFrameID = frameID;
    RH.ClearScene(["frame"]);
    galleryFrameOriginalDimensions.clear(); // Clear stored dimensions when applying new frame

    if (!frameID) {
      patternProps.mattingWidth = 0;
      updateMatting();
      onPatternRestore(patternProps);
    }

    const templateMeshes = scene.meshes.filter((mesh) =>
      mesh.name.startsWith("template"),
    );
    getFrame(frameID)
      .then((frame) => {
        if (!frame) {
          resolve(true);
          return;
        }
        const pathArr = frame.url.split("/");
        const fileName = pathArr.pop();
        // patternProps.currentFrameID = <
        RH.ClearScene(["frame"]);

        BABYLON.SceneLoader.ImportMesh(
          null,
          STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/",
          fileName,
          scene,
          (meshes) => {
            // Store original template dimensions for each template (before any matting is applied)
            templateMeshes.forEach((templateMesh) => {
              const boundingBox = templateMesh.getBoundingInfo().boundingBox;
              const width =
                boundingBox.maximumWorld.x - boundingBox.minimumWorld.x;
              const height =
                boundingBox.maximumWorld.z - boundingBox.minimumWorld.z;
              const centerX =
                (boundingBox.maximumWorld.x + boundingBox.minimumWorld.x) / 2;
              const centerZ =
                (boundingBox.maximumWorld.z + boundingBox.minimumWorld.z) / 2;

              galleryFrameOriginalDimensions.set(templateMesh.name, {
                width: width,
                height: height,
                centerX: centerX,
                centerY: templateMesh.position.y,
                centerZ: centerZ,
              });
            });

            meshes.forEach((mesh, index) => {
              mesh.name = templateMeshes[0].id;
              applyUVPositionFromTemplateMesh(mesh, templateMeshes[0], 0);
              frameOriginalMaterial = mesh.material;

              RH.ProcessMesh(mesh, "frame", index);
            });

            if (templateMeshes.length > 1) {
              for (let i = 1; i < templateMeshes.length; i++) {
                meshes.forEach((originalMesh, index) => {
                  const clonedMesh = originalMesh.clone(
                    `${originalMesh.name}-${i}`,
                    null,
                  );
                  clonedMesh.name = templateMeshes[i].id;
                  // clonedMesh.position = templateMeshes[i].position.clone();
                  applyUVPositionFromTemplateMesh(
                    clonedMesh,
                    templateMeshes[i],
                    0,
                  );
                  // clonedMesh.position.y += 0.0001;

                  RH.ProcessMesh(clonedMesh, "frame", index);
                });
              }
            }

            adjustFrameScale();
            isFrameLoading = false;
            window.requestAnimationFrame(() => (outlineNeedsUpdate = true));
            resolve(true);
          },
          null,
          (err) => {
            console.log(err);
            isFrameLoading = false;
            reject(err);
          },
        );
      })
      .catch((err) => {
        // getFrame() rejects (rather than resolving falsy) when frameID
        // doesn't match anything in the frame catalog. That used to leave
        // this promise permanently unsettled — since applyPatternData
        // `await`s this on every restore, a single stale/unknown saved
        // frameID would silently hang the *entire* restore, including the
        // onPatternRestore() call the UI's selection chips sync from (so a
        // gallery could visually load "fine" while its Frame/Matting/Photos
        // panels never reflect the actually-restored state). Resolve instead
        // of leaving it hanging, same as the "no frame found" (`!frame`) path
        // above.
        console.warn(
          "applyGalleryFrame: frame lookup failed, continuing without one",
          frameID,
          err,
        );
        isFrameLoading = false;
        resolve(true);
      });
  });
}

const applyUVPositionFromTemplateMesh = (mesh, templateMesh, uvIndex) => {
  const boundingInfo = templateMesh.getBoundingInfo();

  if (!boundingInfo) {
    console.error("No bounding info found for the template mesh.");
    return;
  }

  const min = boundingInfo.boundingBox.minimumWorld;
  const max = boundingInfo.boundingBox.maximumWorld;

  const centerX = (min.x + max.x) / 2;
  const centerY = (min.y + max.y) / 2;
  const centerZ = (min.z + max.z) / 2;

  mesh.position = new BABYLON.Vector3(centerX, centerY, centerZ);
};

function adjustPatternFrameScale() {
  const frameMeshes = framePartMeshes;

  const newScaleX = frameOriginalScale.x + 2 * patternProps.mattingWidth;
  const newScaleZ = frameOriginalScale.z + 2 * patternProps.mattingWidth;

  const frameNewPositions = {
    Frame_Back: {
      x: frameOriginalPositions["Frame_Back"].x,
      z: frameOriginalPositions["Frame_Back"].z,
    },

    Frame_CornerBL: {
      x: frameOriginalPositions["Frame_CornerBL"].x + patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_CornerBL"].z + patternProps.mattingWidth,
    },
    Frame_CornerBR: {
      x: frameOriginalPositions["Frame_CornerBR"].x - patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_CornerBR"].z + patternProps.mattingWidth,
    },
    Frame_CornerTL: {
      x: frameOriginalPositions["Frame_CornerTL"].x + patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_CornerTL"].z - patternProps.mattingWidth,
    },
    Frame_CornerTR: {
      x: frameOriginalPositions["Frame_CornerTR"].x - patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_CornerTR"].z - patternProps.mattingWidth,
    },

    Frame_SideB: {
      x: frameOriginalPositions["Frame_SideB"].x,
      z: frameOriginalPositions["Frame_SideB"].z + patternProps.mattingWidth,
    },
    Frame_SideL: {
      x: frameOriginalPositions["Frame_SideL"].x + patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_SideL"].z,
    },
    Frame_SideR: {
      x: frameOriginalPositions["Frame_SideR"].x - patternProps.mattingWidth,
      z: frameOriginalPositions["Frame_SideR"].z,
    },
    Frame_SideT: {
      x: frameOriginalPositions["Frame_SideT"].x,
      z: frameOriginalPositions["Frame_SideT"].z - patternProps.mattingWidth,
    },
  };

  frameMeshes.forEach((frame) => {
    const frameName = Object.keys(frameNewPositions).find((key) =>
      frame.name.includes(key),
    );

    if (frameName) {
      // Adjust position using frameNewPositions
      const position = frameNewPositions[frameName];
      frame.position.x = position.x;
      frame.position.z = position.z;

      if (position.y !== undefined) {
        frame.position.y = position.y;
      }
    }

    if (
      frame.name.includes("Frame_SideT") ||
      frame.name.includes("Frame_SideB")
    ) {
      frame.scaling.x = newScaleX;
    } else if (
      frame.name.includes("Frame_SideL") ||
      frame.name.includes("Frame_SideR")
    ) {
      frame.scaling.z = newScaleZ;
    }
  });

  const mergedFrameMeshes = scene.meshes.filter((mesh) =>
    mesh.name.includes("frame_merged"),
  );

  const mergedFrameMesh = BABYLON.Mesh.MergeMeshes(framePartMeshes, false);
  if (mergedFrameMesh) {
    RH.ProcessMesh(mergedFrameMesh, "frame_merged");
    if (frameOriginalMaterial) {
      mergedFrameMesh.material = frameOriginalMaterial;
      if (mergedFrameMeshes.length > 0) {
        if (
          mergedFrameMeshes[0].metadata &&
          (mergedFrameMeshes[0].metadata.print ||
            mergedFrameMeshes[0].metadata.material?.id ||
            mergedFrameMeshes[0].metadata.colorR)
        ) {
          copyStyle(mergedFrameMesh, mergedFrameMeshes[0]);
        }
      }
    }
  }

  mergedFrameMeshes.forEach((mesh) => mesh.dispose());
  mergedFrameMesh.freezeWorldMatrix();

  framePartMeshes.forEach((mesh) => {
    mesh.setEnabled(false);
  });
  if (!scene.meshes.includes(mergedFrameMesh)) {
    scene.addMesh(mergedFrameMesh);
  }
}

function adjustFrameScale() {
  // if(patternProps.mattingWidth!=0)
  // {
  const frameMeshes = scene.meshes.filter((mesh) =>
    mesh.name.startsWith("frame"),
  );

  frameMeshes.forEach((frame) => {
    // Frame mesh name could be "frame_Shape_01" or "frame_template_Shape_0"
    // We need to get the template mesh name which is "template_Shape_01"
    let templateMeshName = frame.name.replace(/^frame_/, "");

    // If it doesn't start with 'template_', add it
    if (!templateMeshName.startsWith("template_")) {
      templateMeshName = "template_" + templateMeshName;
    }

    // Use stored original dimensions instead of recalculating from current state
    const originalDimensions =
      galleryFrameOriginalDimensions.get(templateMeshName);

    if (!originalDimensions) {
      console.warn(
        `Original dimensions not found for frame: ${frame.name}, template: ${templateMeshName}. Available keys:`,
        Array.from(galleryFrameOriginalDimensions.keys()),
      );
      return;
    }

    // Calculate new scale based on ORIGINAL dimensions + matting
    const newScaleX = originalDimensions.width + 2 * patternProps.mattingWidth;
    const newScaleZ = originalDimensions.height + 2 * patternProps.mattingWidth;

    frame.scaling.x = newScaleX;
    frame.scaling.z = newScaleZ;

    // Position frame at template center (frame should be centered on the template+matting)
    frame.position.x = originalDimensions.centerX;
    frame.position.y = originalDimensions.centerY;
    frame.position.z = originalDimensions.centerZ;
  });
  // adjustCameraToFitMeshes()
  // }
}
/**
 * @param {{name: string, url: string, thumb: string}} accent
 */
function applyAccent(accentIDParam) {
  // Get accentID from parameter or fallback to history for backward compatibility
  const patternData = patternHistory[historyIndex - 1];
  const accentID =
    accentIDParam !== undefined
      ? accentIDParam
      : patternData
        ? patternData.accentID
        : null;
  return new Promise(function (resolve, reject) {
    async function changeGalleryAccent() {
      // reset all accents before applying accent data
      // scene.meshes.forEach((mesh) => {
      //   if (/^template_/.test(mesh.name)) {
      //     RH.EmptySceneOfMeshes(`${mesh.name}_accent`)
      //     mesh.metadata.accentID = null
      //   }
      // })
      templateMeshesCache.forEach((mesh) => {
        RH.EmptySceneOfMeshes(`${mesh.name}_accent`);
        if (mesh.metadata) mesh.metadata.accentID = null;
      });
      for (var key in accentID) {
        const mesh = scene.getMeshByName(key);
        console.log(`Key in accent : ${key}`);
        if (!mesh) {
          console.log(`Mesh accent not found`);
          continue;
        }
        if (!accentID[key]) {
          console.log(`Key accent not found`);
          continue;
        }
        const accent = await getAccent(accentID[key]);
        await applyAccentForMesh(mesh, accent);
      }
      resolve(true);
    }

    async function queueChecker() {
      if (isAccentLoading) {
        resolve(false);
      }
      // else if (topicType === 'gallery') {
      //   await changeGalleryAccent()
      // }
      else {
        applySingleAccent(accentID).then(() => {
          resolve(true);
          if (previousAccentParents.length > 0)
            collectInitialAccentUVs(previousAccentParents[0]);
        });
      }
    }

    if (
      !accentID ||
      (typeof accentID !== "number" && Object.keys(accentID).length === 0)
    ) {
      RH.ClearScene(["accent"]);
      outlineNeedsUpdate = true;
      patternProps.currentAccentID = null;
      patternProps.currentAccentScale = null;
      patternProps.currentAccentNumber = null;
      patternProps.currentAccentRotation = null;
      resolve(false);
    } else {
      queueChecker();
    }
  });
}

/**
 * @param {{name: string, url: string, thumb: string}} sceneObj
 */
function applyScene(sceneObj) {
  return new Promise(function (resolve, reject) {
    function changeAccent() {
      isAccentLoading = true;
      if (sceneObj.id == patternProps.currentSceneID) {
        isAccentLoading = false;
        resolve(false);
      } else {
        const pathArr = sceneObj.url.split("/");
        const fileName = pathArr.pop();
        patternProps.currentSceneID = sceneObj.id;
        RH.ClearScene(["scene"]);
        if (shadowGenerator != null) clearShadowCasters();
        BABYLON.SceneLoader.ImportMesh(
          null,
          STATIC_ASSETS_DIRECTORY + pathArr.join("/") + "/",
          fileName,
          scene,
          (meshes) => {
            RH.ProcessMeshes(meshes, "scene", (mesh) => {
              mesh.position.y -= 0.05;
              if (mesh.material) {
                mesh.material.needDepthPrePass = true;
              }
              mesh.frustumCulled = false;

              if (shadowGenerator != null)
                shadowGenerator.addShadowCaster(mesh);

              mesh.receiveShadows = true;
              mesh.freezeWorldMatrix();
            });
            isAccentLoading = false;
            resolve(true);
          },
          null,
          (err) => {
            console.log(err);
            isAccentLoading = false;
            reject();
          },
        );
      }
    }

    function queueChecker() {
      setTimeout(() => {
        isAccentLoading ? queueChecker() : changeAccent();
      }, 100);
    }
    if (sceneObj) queueChecker();
    else {
      RH.ClearScene(["scene"]);
      patternProps.currentSceneID = null;
      resolve(false);
    }
  });
}

/**
 * @param {BABYLON.Mesh} mesh
 * @param {any} printObject
 */

var applyPrintToAllMeshes = function (mesh, printObject_) {
  const nameLower = mesh.name.toLowerCase();
  let meshesToProcess = [];

  if (nameLower.startsWith("accent") && mesh.parent) {
    const isInstanceGroup = mesh.name.includes("inst");

    meshesToProcess = mesh.parent.getChildren().filter((c) => {
      if (isInstanceGroup) {
        return c.name.includes("inst");
      }
      return !c.name.includes("inst");
    });
  } else {
    const prefixTarget = mesh.name.split("_")[0].toLowerCase() + "_";

    meshesToProcess = scene.meshes.filter((sceneMesh) =>
      sceneMesh.name.toLowerCase().startsWith(prefixTarget),
    );
  }

  meshesToProcess.forEach((targetMesh) => {
    if (targetMesh.isAnInstance) targetMesh = shatterInstance(targetMesh);

    unsetPrint(targetMesh);
    applyPrint(targetMesh, printObject_);
  });

  // Shattering instances above can leave the previous per-instance
  // NodeMaterial clones with nothing referencing them anymore — sweep them
  // up instead of letting them accumulate for the rest of the session.
  RH.SafelyDisposeMaterials();
};

var getTemplateRowCount = function () {
  var uniqueZPositions = [];

  for (var i = 0; i < scene.meshes.length; i++) {
    var mesh = scene.meshes[i];
    if (mesh.name.includes("template_Shape")) {
      var zPos = mesh.position.z;
      if (!uniqueZPositions.includes(zPos)) {
        uniqueZPositions.push(zPos);
      }
    }
  }

  return uniqueZPositions.length;
};

var applyPrint = function (mesh, printObject_) {
  if (mesh.name.startsWith("scene_")) return;

  if (mesh.name.startsWith("frame_") && !mesh.isEnabled()) return;

  // const uvs = mesh.getVerticesData(BABYLON.VertexBuffer.UVKind)

  // let material;
  // if (skipBranching && mesh.material && mesh.material.getClassName() === 'NodeMaterial') {
  //   material = mesh.material;
  // } else {
  //   material = RH.GetMeshMaterial(mesh);
  // }
  // const inputBlocks = material.getInputBlocks()
  const printObject = JSON.parse(JSON.stringify(printObject_));
  let id = printObject.id;
  let url = printObject.url;
  let target = "yPrintTex";
  let useCustomPrint = 0;
  // console.log('Print id : ', id, ' url : ', url)
  if (printObject.egoFileURL || printObject.egoImageFullURL) {
    url = printObject.egoImageFullURL || printObject.egoFileURL;

    // console.log('Should be custom print, url : ', url)
    if (!printObject.tiling) printObject.tiling = 4;

    if (!printObject.channels) printObject.channels = "R";
    if (!printObject.rColor) printObject.rColor = "FFFFFF";

    if (mesh.metadata.print && mesh.metadata.print.egoID == printObject.egoID) {
      unsetPrint(mesh);
      return;
    }
    // RH.ApplyDefaultPrint(mesh.material)
    target = "yCustomPrintTex";
    useCustomPrint = 1;
  } else {
    url = STATIC_ASSETS_DIRECTORY + printObject["maskURL"];
    if (
      (mesh.metadata.print && mesh.metadata.print.id == id) ||
      printObject["maskURL"] == "N/A"
    ) {
      unsetPrint(mesh);
      return;
    }
  }

  if (mesh.isAnInstance) mesh = shatterInstance(mesh);

  mesh.metadata.print = printObject;

  let material;
  material = RH.GetMeshMaterial(mesh);

  if (useCustomPrint === 1) {
    RH.ApplyDefaultPrint(material);
  }
  if (!mesh.metadata.material?.id) {
    RH.ApplyDefaultMaterial(material);
  }

  // let factor = -printObject.tiling / (patternProps.currentTemplate.tiling * 8)
  var defaultTiling = 0.5;
  let factor = -printObject.tiling / (defaultTiling * 8);

  mesh.metadata.printOriginalTile = factor;
  let printTilingMultiplier = 1;
  if (!useCustomPrint && patternProps.currentPrintTiling) {
    printTilingMultiplier = patternProps.currentPrintTiling;
  }
  // if(!useCustomPrint)
  //   factor *= -patternProps.currentPrintTiling

  // if(topicType === "gallery")
  // {
  //   let rowCount = getTemplateRowCount()
  //   factor = -printObject.tiling * rowCount/  8
  //   // console.log('THIS IS FOR GALLERY TILING : ', factor, ', current template tiling : ', patternProps.currentTemplate.tiling)
  // }
  if (
    mesh.name.toLowerCase().includes("accent_") &&
    patternProps.currentTemplate.hasOwnProperty("accentTiling")
  ) {
    factor = -printObject.tiling / patternProps.currentTemplate.accentTiling;
  }
  if (mesh.name.startsWith("accent")) {
    factor *= mesh.scaling.x * mesh.parent.scaling.x;
  }
  // console.log('Mesh name : ', mesh.name, ' factor : ', factor, ' scaling : ', mesh.scaling.x)

  const uPrintTileBlock = material.getBlockByName("uPrintTile");
  if (uPrintTileBlock) uPrintTileBlock.value = factor * printTilingMultiplier;

  const vPrintTileBlock = material.getBlockByName("vPrintTile");
  if (vPrintTileBlock) vPrintTileBlock.value = factor * printTilingMultiplier;

  const useCustomPrintBlock = material.getBlockByName("useCustomPrint");
  if (useCustomPrintBlock) useCustomPrintBlock.value = useCustomPrint;

  // Continuous offset from the tile's own position/scale — replaces the old
  // discrete accentTiling===1|2|3|4 lookup table (kept below, commented, for
  // reference), which only covered 4 fixed tile counts and drifted visibly
  // out of alignment for any other count or once a tile moved off its
  // original grid slot. Matches the same formula in adjustAllPrintTiling so
  // initial print application and later re-tiling stay visually identical.
  const uPrintOffsetBlock = material.getBlockByName("uPrintOffset");
  const vPrintOffsetBlock = material.getBlockByName("vPrintOffset");

  if (mesh.name.startsWith("accent") && mesh.parent) {
    const uTileVal = uPrintTileBlock ? uPrintTileBlock.value : 1.0;
    const vTileVal = vPrintTileBlock ? vPrintTileBlock.value : 1.0;

    const scaleX = mesh.parent.scaling.x || 1.0;
    const scaleZ = mesh.parent.scaling.z || 1.0;

    if (uPrintOffsetBlock) {
      let uOffset = 0.5 + (mesh.parent.position.x * uTileVal) / scaleX;

      uOffset = uOffset % 1;
      if (uOffset < 0) uOffset += 1;
      uPrintOffsetBlock.value = uOffset;
    }

    if (vPrintOffsetBlock) {
      let vOffset = 0.5 + (mesh.parent.position.z * vTileVal) / scaleZ;

      vOffset = vOffset % 1;
      if (vOffset < 0) vOffset += 1;
      vPrintOffsetBlock.value = vOffset;
    }
  } else {
    uPrintOffsetBlock.value = patternProps.currentTemplate.uOffset;
    vPrintOffsetBlock.value = patternProps.currentTemplate.vOffset;
  }
  // --- old discrete lookup table (superseded, kept for reference) ---
  // if (uPrintOffsetBlock) {
  //   uPrintOffsetBlock.value = patternProps.currentTemplate.uOffset;
  //   if (mesh.name.startsWith("accent")) {
  //     const accentTiling = patternProps.currentAccentNumber;
  //     if (accentTiling === 1 || accentTiling === 2) uPrintOffsetBlock.value = 0.5 - mesh.parent.position.x;
  //     else if (accentTiling === 3) uPrintOffsetBlock.value = 0.5;
  //     else if (accentTiling === 4) {
  //       uPrintOffsetBlock.value = (1 + mesh.parent.position.x) % 1;
  //       if (uPrintOffsetBlock.value < 0) uPrintOffsetBlock.value += 1;
  //     }
  //   }
  // }
  //
  // if (vPrintOffsetBlock) {
  //   vPrintOffsetBlock.value = patternProps.currentTemplate.vOffset;
  //   if (mesh.name.startsWith("accent")) {
  //     vPrintOffsetBlock.value += mesh.parent.position.z;
  //     const accentTiling = patternProps.currentAccentNumber;
  //     if (accentTiling === 1 || accentTiling === 2) vPrintOffsetBlock.value = 0.5 - mesh.parent.position.z;
  //     else if (accentTiling === 3) vPrintOffsetBlock.value = 0.5;
  //     else if (accentTiling === 4) {
  //       vPrintOffsetBlock.value = (1 + mesh.parent.position.z) % 1;
  //       if (vPrintOffsetBlock.value < 0) vPrintOffsetBlock.value += 1;
  //     }
  //   }
  // }

  // const lerpNode = material.getBlockByName('PrioritizePrintColor');
  //
  // if (lerpNode) {
  //   lerpNode.value =1;
  // }

  const targetBlock = material.attachedBlocks.find(
    (block) => block.name === target,
  );
  targetBlock.texture = new BABYLON.Texture(url, scene);

  mesh.metadata.print = printObject;
  updateTileRotation(mesh);
  if (!mesh.metadata.material?.id) RH.ApplyDefaultMaterial(mesh.material);
  mesh.material = material;
  applyColorFromPrint(mesh, printObject);

  applyFrameOriginalProperties(mesh);

  if (!isFirstScreenshotTaken) {
    resetScreenshot();
    isFirstScreenshotTaken = true;
  }
};

function applyFrameOriginalProperties(mesh) {
  if (mesh.name.startsWith("frame")) {
    if (!mesh.metadata.material?.id && frameOriginalMaterial) {
      const material = RH.GetMeshMaterial(mesh);
      const smoothness = frameOriginalMaterial.roughness;
      const metalness = frameOriginalMaterial.metallic;

      // console.log('Original frame metalness : ', metalness, ' roughness : ', smoothness)
      const roughnessBlock = material.getBlockByName("roughness");
      if (roughnessBlock) roughnessBlock.value = smoothness;

      const metallicBlock = material.getBlockByName("metallic");
      if (metallicBlock) metallicBlock.value = metalness;

      mesh.material = material;
    }
  }
}

var applyMaterial = function (mesh, materialObj) {
  const currentMatID = mesh.metadata.material
    ? mesh.metadata.material.id
    : "NULL";
  const clickedMatID = materialObj ? materialObj.id : "NULL";

  if (currentMatID === clickedMatID) {
    unsetMaterial(mesh);
    return;
  }
  // if (mesh.metadata.material && mesh.metadata.material.id == materialObj.id) {
  //   unsetMaterial(mesh)
  //   return
  // }

  if (mesh.isAnInstance) mesh = shatterInstance(mesh);

  // A mesh with NO material at all (null) is just as "original" as one with
  // a non-NodeMaterial — both need the default print/color reset below once
  // they're switched onto a cloned NodeMaterial. The old `mesh.material &&`
  // check treated a null material as "already using a NodeMaterial" (false),
  // which skipped that reset.
  const wasUsingOriginalMaterial =
    !mesh.material || mesh.material.getClassName() !== "NodeMaterial";

  mesh.metadata.material = materialObj;
  if (
    mesh.name.toLowerCase().includes("template") &&
    sharedMaterial &&
    (!mesh.material ||
      mesh.material.getClassName() == "StandardMaterial" ||
      mesh.material.name == "sharedMaterial") &&
    !sharedFrom.metadata.print &&
    !sharedFrom.metadata.colorR
  ) {
    mesh.material = sharedMaterial;
    sharedMaterial.name = "sharedMaterial";
    return;
  }

  let material;
  // if (skipBranching && mesh.material && mesh.material.getClassName() === 'NodeMaterial') {
  //   material = mesh.material;
  // } else {
  material = RH.GetMeshMaterial(mesh);
  // }

  const smoothness = materialObj.hasOwnProperty("smoothness")
    ? materialObj["smoothness"]
    : 0.5;
  const normalMapStrength = materialObj.hasOwnProperty("normalMapStrength")
    ? materialObj["normalMapStrength"]
    : 1;
  const metalness = materialObj.hasOwnProperty("metalness")
    ? materialObj["metalness"]
    : 0;

  mesh.metadata.matOriginalTile = materialObj.hasOwnProperty("tiling")
    ? materialObj.tiling
    : 1;
  let matMultiplier = 1;
  if (
    (mesh.name.startsWith("template_") || mesh.name.startsWith("boarder_")) &&
    patternProps.currentTemplate.hasOwnProperty("materialTiling")
  ) {
    matMultiplier = patternProps.currentTemplate.materialTiling;
  }

  if (mesh.name.startsWith("accent_")) {
    matMultiplier = mesh.scaling.x * mesh.parent.scaling.x;
  }

  const roughnessBlock = material.getBlockByName("roughness");
  if (roughnessBlock) roughnessBlock.value = 1 - smoothness;

  const normalStrengthBlock = material.getBlockByName("normalStrength");
  if (normalStrengthBlock) normalStrengthBlock.value = normalMapStrength;

  const metallicBlock = material.getBlockByName("metallic");
  if (metallicBlock) metallicBlock.value = metalness;

  const uTileBlock = material.getBlockByName("uTile");
  if (uTileBlock)
    uTileBlock.value = mesh.metadata.matOriginalTile * matMultiplier;

  const vTileBlock = material.getBlockByName("vTile");
  if (vTileBlock)
    vTileBlock.value = mesh.metadata.matOriginalTile * matMultiplier;

  if (!isFirstScreenshotTaken) {
    resetScreenshot();
    isFirstScreenshotTaken = true;
  }

  if (materialObj.albedo) {
    const baseTextureBlock = material.attachedBlocks.find(
      (block) => block.name === "yBaseColorTex",
    );
    baseTextureBlock.texture = new BABYLON.Texture(
      STATIC_ASSETS_DIRECTORY + materialObj.albedo,
      scene,
    );
  }
  if (materialObj.normal) {
    const normalBlock = material.attachedBlocks.find(
      (block) => block.name === "yNormalTex",
    );
    normalBlock.texture = new BABYLON.Texture(
      STATIC_ASSETS_DIRECTORY + materialObj.normal,
      scene,
    );
  }
  if (materialObj.r) {
    const roughnessTexBlock = material.attachedBlocks.find(
      (block) => block.name === "roughnessTexture",
    );
    roughnessTexBlock.texture = new BABYLON.Texture(
      STATIC_ASSETS_DIRECTORY + materialObj.r,
      scene,
    );
  } else {
    const roughnessTexBlock = material.attachedBlocks.find(
      (block) => block.name === "roughnessTexture",
    );
    roughnessTexBlock.texture = null;
  }

  const uOffsetBlock = material.attachedBlocks.find(
    (block) => block.name === "uOffset",
  );
  const vOffsetBlock = material.attachedBlocks.find(
    (block) => block.name === "vOffset",
  );

  // Same continuous per-tile offset as adjustAccentMaterialTiling — an
  // accent tile's material offset needs to track *where that tile actually
  // is* (position/scale under its parent), not just the flat materialObj
  // offset every tile used to share regardless of position.
  if (mesh.name.startsWith("accent") && mesh.parent) {
    const uTileVal = uTileBlock ? uTileBlock.value : 1.0;
    const vTileVal = vTileBlock ? vTileBlock.value : 1.0;

    const scaleX = mesh.parent.scaling.x || 1.0;
    const scaleZ = mesh.parent.scaling.z || 1.0;

    if (uOffsetBlock) {
      let uOffset = 0 + (mesh.parent.position.x * uTileVal) / scaleX;

      if (materialObj.uOffset) uOffset += materialObj.uOffset;
      uOffset = uOffset % 1;
      if (uOffset < 0) uOffset += 1;
      uOffsetBlock.value = uOffset;
    }

    if (vOffsetBlock) {
      let vOffset = 0 + (mesh.parent.position.z * vTileVal) / scaleZ;

      if (materialObj.vOffset) vOffset += materialObj.vOffset;
      vOffset = vOffset % 1;
      if (vOffset < 0) vOffset += 1;
      vOffsetBlock.value = vOffset;
    }
  } else {
    if (uOffsetBlock) {
      uOffsetBlock.value = materialObj.uOffset ? materialObj.uOffset : 0;
    }
    if (vOffsetBlock) {
      vOffsetBlock.value = materialObj.vOffset ? materialObj.vOffset : 0;
    }
  }

  mesh.material = material;
  // Generalized from the old frame_merged-only branch (which forced a gray
  // default color + only added the mesh back to the scene for frame_merged
  // specifically): any mesh transitioning off its original material — a
  // non-NodeMaterial, or no material at all — onto a fresh NodeMaterial
  // clone needs its default print/color reset applied, or it can inherit
  // stale block values baked into the cloned template. This now runs for
  // every mesh, not just frame_merged.
  if (wasUsingOriginalMaterial) {
    RH.ApplyDefaultPrint(mesh.material);
    RH.ApplyDefaultColor(mesh.material);
  }

  if (!scene.meshes.includes(mesh)) {
    scene.addMesh(mesh);
  }

  if (
    /^template_/.test(mesh.name) &&
    !mesh.metadata.print &&
    !mesh.metadata.colorR &&
    !/_Merge$/.test(mesh.name)
  ) {
    sharedMaterial = material;
    sharedFrom = mesh;
  }

  RH.SafelyDisposeMaterials();
};

var applyMaterialOnSameSurfaces = function (
  mesh2,
  materialObj,
  applyAll = false,
) {
  sharedMaterial = null;
  sharedFrom = null;

  // set material to each mesh for gallery pattern only
  // if (topicType === 'gallery' && !applyAll) {
  //   applyMaterial(mesh2, materialObj)
  //   return
  // }

  const nameLower = mesh2.name.toLowerCase();
  const validPrefixes = [
    "scene_",
    "template_",
    "accent_",
    "boarder_",
    "frame_",
    "matting_",
  ];
  const matchedPrefix = validPrefixes.find((p) => nameLower.startsWith(p));

  if (matchedPrefix) {
    let meshesToProcess = [];

    if (matchedPrefix === "accent_" && mesh2.parent) {
      const isInstanceType = mesh2.name.includes("_inst_");

      if (isInstanceType) {
        const prefixParts = mesh2.name.split("_inst_");
        const exactTilePrefix = prefixParts[0] + "_inst_";

        meshesToProcess = mesh2.parent
          .getChildren()
          .filter((mesh) => mesh.name.startsWith(exactTilePrefix));
      } else {
        meshesToProcess = mesh2.parent
          .getChildren()
          .filter((mesh) => !mesh.name.includes("_inst_"));
      }
    } else {
      meshesToProcess = scene.meshes.filter((mesh) => {
        const meshNameLower = mesh.name.toLowerCase();
        const isMatch =
          meshNameLower.startsWith(matchedPrefix) &&
          !meshNameLower.includes("overlay");

        if (matchedPrefix === "frame_" && !mesh.isEnabled()) {
          return false;
        }

        return isMatch;
      });
    }

    meshesToProcess.forEach((mesh) => {
      if (mesh.metadata == null) {
        mesh.metadata = {};
      }
      applyMaterial(mesh, materialObj);
    });
  }
};

var applyColorToAllMesh = function (mesh, string) {
  const nameLower = mesh.name.toLowerCase();
  let meshesToProcess = [];

  if (nameLower.startsWith("accent") && mesh.parent) {
    const isInstanceGroup = mesh.name.includes("inst");

    meshesToProcess = mesh.parent.getChildren().filter((c) => {
      if (isInstanceGroup) {
        return c.name.includes("inst");
      }
      return !c.name.includes("inst");
    });
  } else {
    const prefixTarget = mesh.name.split("_")[0].toLowerCase() + "_";

    meshesToProcess = scene.meshes.filter((sceneMesh) =>
      sceneMesh.name.toLowerCase().startsWith(prefixTarget),
    );
  }

  meshesToProcess.forEach((targetMesh) => {
    if (targetMesh.isAnInstance) targetMesh = shatterInstance(targetMesh);

    if (targetMesh.metadata && targetMesh.metadata.colorR) {
      unsetColor(targetMesh);
    }

    applyColorArray(targetMesh, string);
  });
};

var applyColor = function (mesh, string) {
  const material = RH.GetMeshMaterial(mesh);
  RH.ApplyDefaultColor(material);
  if (!mesh.metadata.material?.id) RH.ApplyDefaultMaterial(material);
  if (!mesh.metadata.print?.id) RH.ApplyDefaultPrint(material);
  const color = BABYLON.Color3.FromHexString(string);
  const colorRBlock = material.getBlockByName("colorR");
  if (colorRBlock) colorRBlock.value = color;
  mesh.metadata.colorR = {
    r: color.r,
    g: color.g,
    b: color.b,
  };
  mesh.material = material;
};

var applyColorArray = function (mesh, colorArray, ignoreUnset = false) {
  if (mesh.name.startsWith("frame_") && !mesh.isEnabled()) return;

  // let material;
  // if (skipBranching && mesh.material && mesh.material.getClassName() === 'NodeMaterial') {
  //   material = mesh.material;
  // } else {
  //   material = RH.GetMeshMaterial(mesh);
  // }

  let colorRString, colorGString, colorBString, colorAString;

  if (mesh.metadata.colorR) {
    colorRString = new BABYLON.Color3(
      mesh.metadata.colorR.r,
      mesh.metadata.colorR.g,
      mesh.metadata.colorR.b,
    ).toHexString();
  }

  if (mesh.metadata.colorG) {
    colorGString = new BABYLON.Color3(
      mesh.metadata.colorG.r,
      mesh.metadata.colorG.g,
      mesh.metadata.colorG.b,
    ).toHexString();
  }

  if (mesh.metadata.colorB) {
    colorBString = new BABYLON.Color3(
      mesh.metadata.colorB.r,
      mesh.metadata.colorB.g,
      mesh.metadata.colorB.b,
    ).toHexString();
  }

  if (mesh.metadata.colorA) {
    colorAString = new BABYLON.Color3(
      mesh.metadata.colorA.r,
      mesh.metadata.colorA.g,
      mesh.metadata.colorA.b,
    ).toHexString();
  }

  const allColorsMatch =
    (colorRString === undefined || colorRString === colorArray[0]) &&
    (colorGString === undefined || colorGString === colorArray[1]) &&
    (colorBString === undefined || colorBString === colorArray[2]) &&
    (colorAString === undefined || colorAString === colorArray[3]);

  const atLeastOneColorDefined =
    colorRString || colorGString || colorBString || colorAString;

  if (atLeastOneColorDefined && allColorsMatch && !ignoreUnset) {
    unsetColor(mesh);
    return;
  }

  if (mesh.isAnInstance) mesh = shatterInstance(mesh);

  const metadataNames = ["colorR", "colorG", "colorB", "colorA"];

  colorArray.forEach((colorString, index) => {
    const color = BABYLON.Color3.FromHexString(colorString);
    mesh.metadata[metadataNames[index]] = {
      r: color.r,
      g: color.g,
      b: color.b,
    };
  });
  let material;
  material = RH.GetMeshMaterial(mesh);

  // RH.ApplyDefaultColor(material)
  if (!mesh.metadata.material?.id) RH.ApplyDefaultMaterial(material);
  if (!mesh.metadata.print?.id) RH.ApplyDefaultPrint(material);

  const rBlock = material.getBlockByName("colorR");
  const gBlock = material.getBlockByName("colorG");
  const bBlock = material.getBlockByName("colorB");
  const aBlock = material.getBlockByName("colorA");

  const useR = material.getBlockByName("useR");
  const useG = material.getBlockByName("useG");
  const useB = material.getBlockByName("useB");
  const useA = material.getBlockByName("useA");

  const blocks = [rBlock, gBlock, bBlock, aBlock];
  const useBlocks = [useR, useG, useB, useA];

  colorArray.forEach((colorString, index) => {
    const color = BABYLON.Color3.FromHexString(colorString);
    if (useBlocks[index] && useBlocks[index].value == 1) {
      if (blocks[index]) {
        blocks[index].value = color;
      }
    }
  });
  // const metadataNames = ['colorR', 'colorG', 'colorB', 'colorA'];
  //
  // colorArray.forEach((colorString, index) => {
  //   const color = BABYLON.Color3.FromHexString(colorString)
  //   // const blockName = blockNames[index]
  //   // const useName = useNames[index]
  //   const colorBlock = blocks[index];
  //   const useBlock = useBlocks[index];
  //
  //   if (useBlock && useBlock.value == 1) {
  //     if (colorBlock) {
  //       colorBlock.value = color
  //     }
  //   }
  //   mesh.metadata[metadataNames[index]] = {
  //     r: color.r,
  //     g: color.g,
  //     b: color.b,
  //   }
  // })

  mesh.material = material;
  mesh.receiveShadows = false;
  applyFrameOriginalProperties(mesh);
  if (!isFirstScreenshotTaken) {
    resetScreenshot();
    isFirstScreenshotTaken = true;
  }
};

function getTotalVertexCount() {
  let totalVertexCount = 0;

  scene.meshes.forEach((mesh) => {
    if (mesh.isVerticesDataPresent(BABYLON.VertexBuffer.PositionKind)) {
      totalVertexCount += mesh.getTotalVertices();
    }
  });

  // console.log(`Total vertex count in the scene: ${totalVertexCount}`);
  return totalVertexCount;
}

var applyColorFromPrint = function (mesh, printObject) {
  // console.log(`Apply color from print : ${mesh.name}`)
  const colorChannels = ["r", "g", "b", "a"];

  if (mesh.metadata.colorR) delete mesh.metadata.colorR;
  if (mesh.metadata.colorG) delete mesh.metadata.colorG;
  if (mesh.metadata.colorB) delete mesh.metadata.colorB;
  if (mesh.metadata.colorA) delete mesh.metadata.colorA;

  const useBlocks = ["useR", "useG", "useB", "useA"];
  useBlocks.forEach((name) => {
    const block = mesh.material.getBlockByName(name);
    if (block) block.value = 0;
  });

  colorChannels.forEach((channel) => {
    const upperCaseChannelCode = channel.toUpperCase();
    if (printObject.channels?.includes(upperCaseChannelCode)) {
      const color = BABYLON.Color3.FromHexString(
        "#" + printObject[channel + "Color"],
      );

      const colorBlock = mesh.material.getBlockByName(
        "color" + upperCaseChannelCode,
      );
      if (colorBlock) colorBlock.value = color;

      const useBlock = mesh.material.getBlockByName(
        "use" + upperCaseChannelCode,
      );
      if (useBlock) useBlock.value = 1;
    }
  });
};

function unsetPrint(mesh) {
  if (mesh.metadata && mesh.metadata.print) {
    delete mesh.metadata.print;
  }

  mesh.material = RH.GetMeshMaterial(mesh);

  if (mesh.material && mesh.material.getClassName() === "NodeMaterial") {
    RH.ApplyDefaultPrint(mesh.material);
  }

  // if (mesh.material.getBlockByName) {
  //   const lerpNode = mesh.material.getBlockByName('PrioritizePrintColor');
  //
  //   if (lerpNode) {
  //     lerpNode.value = 0;
  //   }
  // }

  RH.ResetMesh(mesh);

  if (mesh.name.startsWith("frame")) {
    if (shouldRevertToOriginalMaterial(mesh)) {
      // Don't dispose() the outgoing NodeMaterial — it's the shared
      // sharedMat_* cache clone (see getMeshMaterial), so other frame
      // meshes with the same mat/print/color/parent combo may still be
      // pointing at it.
      mesh.material = frameOriginalMaterial;
    }
    // if (frameOriginalMaterial) {
    //   console.log(`🔄 Restoring original material for ${mesh.name}`)
    //   mesh.material = frameOriginalMaterial
    // } else {
    //   console.warn(
    //     `⚠ frameOriginalMaterial is undefined, cannot restore material for ${mesh.name}`,
    //   )
    // }
  }
}

function shouldRevertToOriginalMaterial(mesh) {
  if (!mesh.metadata) return true;

  if (mesh.metadata.print) {
    // console.log(`%c   -> FALSE: Mesh has an active Print.`, 'color: #e74c3c');
    return false;
  }

  if (mesh.metadata.material?.id) {
    // console.log(`%c   -> FALSE: Mesh has a custom Material ID (${mesh.metadata.material.id}).`, 'color: #e74c3c');
    return false;
  }

  if (mesh.metadata.colorR) {
    const r = mesh.metadata.colorR.r;
    const g = mesh.metadata.colorR.g;
    const b = mesh.metadata.colorR.b;
    const a = mesh.metadata.colorA ? mesh.metadata.colorA.a : 1;

    const checkColor = new BABYLON.Color4(r, g, b, a);
    const hex = checkColor.toHexString().toUpperCase();

    if (hex === "#808080FF") {
      // console.log(`%c   -> TRUE: Color matches Default Gray (${hex}).`, 'color: #2ecc71');

      return true;
    } else {
      // console.log(`%c   -> FALSE: Mesh has Custom Color (${hex}).`, 'color: #e74c3c');
      return false;
    }
  }

  // console.log(`%c   -> TRUE: Metadata exists but has no Print/Material/Color keys.`, 'color: #2ecc71');
  return true;
}

function unsetMaterial(mesh) {
  // if (mesh.material && mesh.material.getClassName() === 'NodeMaterial') {
  //   if (mesh.name.startsWith('frame')){ //&& mesh.metadata.colorR == BABYLON.Color3.Gray()) {
  //     mesh.material = frameOriginalMaterial
  //   } else RH.ApplyDefaultMaterial(mesh.material)
  // }

  if (mesh.metadata) {
    delete mesh.metadata.material;
  }

  // mesh.metadata && delete mesh.metadata.material
  sharedMaterial = null;
  sharedFrom = null;
  mesh.material = RH.GetMeshMaterial(mesh);
  if (mesh.name.startsWith("frame") && shouldRevertToOriginalMaterial(mesh)) {
    // if (mesh.material && mesh.material.getClassName() === 'NodeMaterial') {
    //   mesh.material.dispose();
    // }
    mesh.material = frameOriginalMaterial;
    if (mesh.metadata) {
      delete mesh.metadata.colorR;
      delete mesh.metadata.colorG;
      delete mesh.metadata.colorB;
      delete mesh.metadata.colorA;
    }
    return;
  }

  if (mesh.material && mesh.material.getClassName() === "NodeMaterial") {
    RH.ApplyDefaultMaterial(mesh.material);
  }

  RH.ResetMesh(mesh);

  // if (mesh.metadata && (!mesh.material || mesh.material.getClassName() !== 'NodeMaterial')) {
  //   delete mesh.metadata.shaderID;
  // }
  RH.SafelyDisposeMaterials();
}

function unsetAccent() {
  // console.log(`UNSET ACCENT`)
  RH.EmptySceneOfMeshes("accent");
  outlineNeedsUpdate = true;
  patternProps.currentAccentID = null;
  patternProps.currentAccentScale = null;
  patternProps.currentAccentNumber = null;
  patternProps.currentAccentRotation = null;
  individualAccentScale = 1;
  toggleSliderVisibility(false);
  onPatternRestore(patternProps);
}

function unsetFrame() {
  RH.EmptySceneOfMeshes("frame");
  patternProps.currentFrameID = null;
  // patternProps.currentPatternFrameID = null
  patternProps.mattingWidth = 0;
  galleryFrameOriginalDimensions.clear(); // Clear stored frame dimensions
  updateMatting();
}

function unsetScene() {
  RH.EmptySceneOfMeshes("scene");
  patternProps.currentSceneID = null;
  onPatternRestore(patternProps);
}

function unsetColor(mesh) {
  // if(mesh.name.startsWith("frame")) {
  //   return;
  // }

  // console.log(`Unset color`)
  mesh.metadata && delete mesh.metadata.colorR;
  mesh.metadata && delete mesh.metadata.colorG;
  mesh.metadata && delete mesh.metadata.colorB;
  mesh.metadata && delete mesh.metadata.colorA;

  mesh.material = RH.GetMeshMaterial(mesh);

  if (mesh.material && mesh.material.getClassName() === "NodeMaterial") {
    RH.ApplyDefaultColor(mesh.material);

    // if(mesh.name.startsWith("frame"))
    // {
    //   mesh.material = frameOriginalMaterial;
    // }
    // else {

    if (mesh.metadata.print) applyColorFromPrint(mesh, mesh.metadata.print);
  }

  if (mesh.name.startsWith("frame") && !mesh.metadata.material) {
    if (shouldRevertToOriginalMaterial(mesh)) {
      // Same shared-material caution as unsetPrint above — no dispose().
      mesh.material = frameOriginalMaterial;
    }
  } else {
    RH.ResetMesh(mesh);
  }
}

function undoPatternEdit() {
  if (isRestoring) return;
  //historyIndex--
  if (historyIndex <= 1) {
    historyIndex = 1;
  } else {
    historyIndex--;
    const previousPatternData = patternHistory[historyIndex - 1];

    // console.log(
    //     `%c [UNDO] %c historyIndex=${historyIndex} — restoring pattern data: `,
    //     'background: #2980b9; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;',
    //     'background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;',
    //     previousPatternData
    // );

    RestorePattern(previousPatternData, null, () => {
      RH.CheckReadyBeforeUpdate(() => onEdit(previousPatternData));
    });
  }
}

function redoPatternEdit() {
  if (isRestoring) return;

  if (historyIndex >= patternHistory.length) {
    historyIndex = patternHistory.length;
  } else {
    historyIndex++;
    const nextPatternData = patternHistory[historyIndex - 1];
    // console.log(
    //     `%c [REDO] %c historyIndex=${historyIndex} — restoring pattern data: `,
    //     'background: #27ae60; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;',
    //     'background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;',
    //     nextPatternData
    // );

    RestorePattern(nextPatternData, null, () => {
      RH.CheckReadyBeforeUpdate(() => onEdit(nextPatternData));
    });
  }
}

function savePattern(isNew = true, cb) {
  if (!applyPatternFinished) {
    return;
  }

  RH.CheckReadyBeforeUpdate(() => {
    onEdit(serializePattern(isNew));
    cb && cb();

    // if(!isFirstScreenshotTaken) {
    //   console.log(
    //       `%c [SCREENSHOT] First Screenshot Taken `,
    //       'background: #e17055; color: white; font-weight: bold; padding: 4px; border-radius: 4px;'
    //   );
    //   resetScreenshot()
    //   isFirstScreenshotTaken = true;
    // }
  });
}

function resetScreenshot() {
  RH.TakeScreenShot(() => {}, 512);
}

export function PerformOperation(operation, argument1, argument2) {
  switch (operation) {
    case "toggleOverlay":
      RH.ToggleOverlay(argument1);
      break;
    case "toggleInspector":
      argument1
        ? Inspector.Show(scene, { enableClose: false })
        : Inspector.Hide();
      break;
    case "screenshot":
      const targetLight = scene.lights.find((light) => light.name === "light1");

      // console.log('Topic type : ', topicType)
      // let originalIntensity;
      // let originalDirection;
      //
      // if (targetLight && topicType === 'custom_print') {
      //     originalIntensity = targetLight.intensity;
      //     originalDirection = targetLight.direction.clone();
      //
      //     targetLight.intensity = 2.55;
      //     targetLight.direction = new BABYLON.Vector3(0, -0.1, 0);
      // }

      RH.TakeScreenShot(argument1, 512);

      // if (targetLight && topicType === 'custom_print') {
      //   setTimeout(() => {
      //     targetLight.intensity = originalIntensity;
      //     targetLight.direction = originalDirection;
      //     console.log(`Restored original intensity and direction for light: ${targetLight.name}`);
      //   }, 1000);
      // }
      break;
    case "undoPatternEdit":
      clearPartialActions();
      undoPatternEdit();
      break;
    case "redoPatternEdit":
      clearPartialActions();
      redoPatternEdit();
      break;
    case "applyText":
      RH.SetTextOn3DRenderer(argument1);
      break;
    case "updateMergeMode":
      if (applicationMode != argument1) {
        clearPartialActions();
        applicationMode = argument1;
        if (applicationMode === APPLICATION_MODES.FULL_SCREEN)
          toggleCameraForFullscreen(applicationMode);
      } else {
        if (applicationMode === APPLICATION_MODES.SPLIT_SURFACES) {
          unmergeSelectedMeshes();
          applicationMode = APPLICATION_MODES.NONE;
        } else if (applicationMode === APPLICATION_MODES.MERGE_SURFACES) {
          mergeSelectedMeshes();
        } else if (applicationMode === APPLICATION_MODES.FULL_SCREEN) {
          toggleCameraForFullscreen(false);
          applicationMode = APPLICATION_MODES.NONE;
        }
        // applicationMode = APPLICATION_MODES.NONE
      }
      break;
    default:
      break;
  }
}

function clearPartialActions() {
  meshesSelectedForMerging.clear();
  RH.ShowHighlightOn(meshesSelectedForMerging);
}

function mergeSelectedMeshes(skipSave) {
  let mergeMeshParent;
  if (meshesSelectedForMerging.size > 1) {
    //check already merged mesh is being merged
    let selectedMeshesArray = Array.from(meshesSelectedForMerging);
    const firstMesh = selectedMeshesArray[0];
    if (firstMesh) {
      mergeMeshParent = firstMesh.parent;
    }

    let previousMeshType = firstMesh.name.split("_")[0];
    let previousMesh = firstMesh;
    let differentMeshTypes = false;
    for (let i = 0; i < selectedMeshesArray.length; i++) {
      if (!selectedMeshesArray[i]) continue;
      const currentMesh = selectedMeshesArray[i];
      const currentMeshType = selectedMeshesArray[i].name.split("_")[0];
      // if (topicType === 'gallery' && currentMeshType === 'template') {
      //   alert('You can not merge individual meshes on gallery.')
      //   return
      // }
      if (previousMeshType !== currentMeshType) {
        differentMeshTypes = true;
        alert("Different mesh types selected. Cannot Merge.");
        break;
      }
      if (
        currentMesh.name.includes("accent") &&
        previousMesh?.parent !== currentMesh.parent
      ) {
        alert("Cannot merge accents from different groups.");

        meshesSelectedForMerging.forEach((mesh) => {
          if (mesh.parent !== mergeMeshParent) {
            // console.log(`Removing mesh ${mesh.name} from selection due to different parent.`)
            meshesSelectedForMerging.delete(mesh);
          }
        });

        RH.ShowHighlightOn(meshesSelectedForMerging);

        return;
      }
      previousMeshType = currentMeshType;
      previousMesh = currentMesh;
    }

    if (!differentMeshTypes) {
      selectedMeshesArray.forEach((mesh) => {
        if (currentMerges[mesh.name]) {
          meshesSelectedForMerging.delete(mesh);
          currentMerges[mesh.name].forEach((meshName) => {
            meshesSelectedForMerging.add(
              scene.meshes.find((mesh) => mesh.name === meshName),
            );
          });
          disposeMerge(mesh.name);
        }
      });

      const mergedMeshNames = [];
      selectedMeshesArray = Array.from(meshesSelectedForMerging);
      const newMesh = BABYLON.Mesh.MergeMeshes(selectedMeshesArray, false);
      outlineNeedsUpdate = true;

      if (newMesh) {
        const allSourcesInvisible = selectedMeshesArray.every(
          (mesh) => mesh.isVisible === false,
        );
        if (allSourcesInvisible) {
          newMesh.isVisible = false;
          newMesh.setEnabled(false);
        }
      }

      selectedMeshesArray.forEach((mesh) => {
        mergedMeshNames.push(mesh.name);

        mesh.setEnabled(false);
      });
      const generatedName = generateMergedMeshName(selectedMeshesArray[0].name);

      newMesh.name = generatedName;
      newMesh.id = generatedName;

      RH.ProcessMesh(newMesh, previousMeshType, 1);

      // const positionData = newMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
      // if (positionData && mergeMeshParent) {
      //
      //   const normalizedPositionData = [];
      //   const parentOffset = mergeMeshParent ? accentParentOffsets.get(mergeMeshParent.name) : null;
      //   const scaling = mergeMeshParent.scaling
      //
      //   console.log('Position : ', positionData)
      //   if (parentOffset) {
      //     console.log(`Parent Offset ${mergeMeshParent.name}:`, parentOffset, ' accent : ' , patternProps.currentAccentNumber);
      //   }
      //   for (let i = 0; i < positionData.length; i += 3) {
      //     normalizedPositionData.push(
      //         positionData[i] - (parentOffset ? parentOffset.x  : 0) * scaling.x,
      //         positionData[i + 1],
      //         positionData[i + 2] - (parentOffset ? parentOffset.y : 0)  * scaling.z
      //     );
      //   }
      //
      //
      //   const processedMeshName = newMesh.name.split('.').pop();
      //
      //   const nameExists = initialAccentUVs.some(entry => entry.meshName === processedMeshName);
      //   console.log('Position normal', processedMeshName, ' : ', normalizedPositionData)
      //
      //   if (!nameExists) {
      //     initialAccentUVs.push({
      //       meshName: processedMeshName,
      //       positionData: [...normalizedPositionData]
      //     });
      //   }
      // }

      if (mergeMeshParent) {
        newMesh.setParent(mergeMeshParent);
        // newMesh.parent = mergeMeshParent
        // newMesh.rotation.y = BABYLON.Tools.ToRadians(360) - mergeMeshParent.rotation.y
        //
        // const parentScale = mergeMeshParent.scaling
        // if (parentScale.x !== 1 || parentScale.y !== 1 || parentScale.z !== 1) {
        //   newMesh.scaling = new BABYLON.Vector3(
        //     1 / parentScale.x,
        //     1 / parentScale.y,
        //     1 / parentScale.z,
        //   )
        // }
      }
      //apply some material here.
      const meshes = Array.from(meshesSelectedForMerging);
      if (meshes[0].metadata.material) {
        // console.log('Apply mat from merges')
        applyMaterial(newMesh, meshes[0].metadata.material);
      }
      const printedMesh = meshes.find((mesh) => mesh.metadata.print);
      printedMesh && applyPrint(newMesh, printedMesh.metadata.print);

      const hexColors = [];
      const coloredMesh = meshes.find((mesh) => mesh.metadata.colorR);
      // applyColorsFromMesh(coloredMesh)
      if (coloredMesh) {
        const r = coloredMesh.metadata.colorR.r;
        const g = coloredMesh.metadata.colorR.g;
        const b = coloredMesh.metadata.colorR.b;
        hexColors.push(new BABYLON.Color3(r, g, b).toHexString());

        if (coloredMesh.metadata.colorG) {
          hexColors.push(
            new BABYLON.Color3(
              coloredMesh.metadata.colorG.r,
              coloredMesh.metadata.colorG.g,
              coloredMesh.metadata.colorG.b,
            ).toHexString(),
          );
        }
        if (coloredMesh.metadata.colorB) {
          hexColors.push(
            new BABYLON.Color3(
              coloredMesh.metadata.colorB.r,
              coloredMesh.metadata.colorB.g,
              coloredMesh.metadata.colorB.b,
            ).toHexString(),
          );
        }
        if (coloredMesh.metadata.colorA) {
          hexColors.push(
            new BABYLON.Color3(
              coloredMesh.metadata.colorA.r,
              coloredMesh.metadata.colorA.g,
              coloredMesh.metadata.colorA.b,
            ).toHexString(),
          );
        }
        // hexColors.push(new BABYLON.Color3(r, g, b).toHexString())
        // applyColor(newMesh, new BABYLON.Color3(r, g, b).toHexString())
        applyColorArray(newMesh, hexColors);
      }

      // console.trace(
      //     `%c [MERGE SUCCESS] %c Created: ${newMesh.name} (from ${mergedMeshNames.length} meshes) `,
      //     'background: #27ae60; color: white; font-weight: bold; padding: 4px; border-radius: 4px 0 0 4px;',
      //     'background: #2c3e50; color: white; padding: 4px; border-radius: 0 4px 4px 0;'
      // );
      if (!currentMerges[newMesh.name])
        currentMerges[newMesh.name] = mergedMeshNames;

      if (!skipSave) {
        RH.SuperHighlight(newMesh);
        savePattern(true, async () => {
          applySurfaceProperties();
        });
      }
    }
  }

  meshesSelectedForMerging.clear();
  RH.ShowHighlightOn(meshesSelectedForMerging);

  // OPTIMIZED: Rebuild caches because original meshes were destroyed and a new merged mesh was born
  templateMeshesCache = scene.meshes.filter((m) =>
    m.name.startsWith("template"),
  );

  setMode(APPLICATION_MODES.NONE);
}

function unmergeSelectedMeshes(skipSave) {
  if (meshesSelectedForMerging.size >= 1) {
    meshesSelectedForMerging.forEach((mesh) => {
      disposeMerge(mesh.name);
      // console.log('Dispose merged mesh : ', mesh.name)
    });
    meshesSelectedForMerging.clear();

    RH.ShowHighlightOn(meshesSelectedForMerging);
    savePattern();
  }
}

function disposeMerge(mergedMeshName) {
  const mergedMesh = scene.getMeshByName(mergedMeshName);
  if (mergedMesh) {
    // console.trace(
    //     `%c [DISPOSE MERGE] %c Disposing mesh "${mergedMesh.name}" `,
    //     'background: #c0392b; color: white; font-weight: bold; padding: 2px; border-radius: 4px 0 0 4px;',
    //     'background: #2c3e50; color: white; padding: 2px; border-radius: 0 4px 4px 0;'
    // );
    mergedMesh.dispose();
    outlineNeedsUpdate = true;
  }

  currentMerges[mergedMeshName] &&
    currentMerges[mergedMeshName].forEach((meshName) => {
      const mesh = scene.meshes.find((mesh) => mesh.name === meshName);
      if (mesh) {
        mesh.setEnabled(true);
        // console.log(`Mesh enabled: ${mesh.name}`);
      } else {
        console.log(`Mesh not found: ${meshName}`);
      }
    });
  delete currentMerges[mergedMeshName];
}

// function updateBoarder() {
//   const templateMerges = Object.keys(currentMerges)
//   for (let i = 0; i < templateMerges.length; i++) {
//     if (/^boarder_/.test(templateMerges[i])) {
//       delete currentMerges[templateMerges[i]]
//     }
//   }
//   if (patternProps.boarderWidth && patternProps.boarderType) {
//     RH.CreateBoarder(patternProps.boarderWidth, patternProps.boarderType, topicType === 'gallery')
//     outlineNeedsUpdate = true
//   }
// }

function updateMatting() {
  const previousMattingMetadata = scene.meshes
    .filter((mesh) => mesh.name.startsWith("matting"))
    .map((mesh) => {
      return {
        name: mesh.name,
        metadata: { ...mesh.metadata },
      };
    });

  RH.CreateMatting(patternProps.mattingWidth, topicType === "gallery");
  outlineNeedsUpdate = true;

  // Check which frame is actually set, not just topicType
  // A pattern can use gallery frames and vice versa
  if (patternProps.currentFrameID != null) {
    // adjustFrameScale() only has data to work with for frames applied via
    // applyGalleryFrame (it reads originals out of galleryFrameOriginalDimensions,
    // which only that function populates) — route by which frame pipeline is
    // actually active, same as the 'frame' case in SetCurrentItem, instead of
    // always calling the pattern-only rescale for both.
    if (topicType === "gallery") {
      adjustFrameScale();
    } else {
      adjustPatternFrameScale();
    }
  }

  const newMattingMeshes = scene.meshes.filter((mesh) =>
    mesh.name.startsWith("matting"),
  );

  newMattingMeshes.forEach((newMesh) => {
    const oldMetadata = previousMattingMetadata.find(
      (old) => old.name === newMesh.name,
    );
    if (oldMetadata) {
      if (oldMetadata.metadata.print) {
        applyPrint(newMesh, oldMetadata.metadata.print);
      }
      if (oldMetadata.metadata.material) {
        // console.log('Apply mat from matting')
        applyMaterial(newMesh, oldMetadata.metadata.material);
      }

      const hexColors = [];
      if (oldMetadata.metadata.colorR) {
        hexColors.push(
          new BABYLON.Color3(
            oldMetadata.metadata.colorR.r,
            oldMetadata.metadata.colorR.g,
            oldMetadata.metadata.colorR.b,
          ).toHexString(),
        );
      }
      if (oldMetadata.metadata.colorG) {
        hexColors.push(
          new BABYLON.Color3(
            oldMetadata.metadata.colorG.r,
            oldMetadata.metadata.colorG.g,
            oldMetadata.metadata.colorG.b,
          ).toHexString(),
        );
      }
      if (oldMetadata.metadata.colorB) {
        hexColors.push(
          new BABYLON.Color3(
            oldMetadata.metadata.colorB.r,
            oldMetadata.metadata.colorB.g,
            oldMetadata.metadata.colorB.b,
          ).toHexString(),
        );
      }
      if (oldMetadata.metadata.colorA) {
        hexColors.push(
          new BABYLON.Color3(
            oldMetadata.metadata.colorA.r,
            oldMetadata.metadata.colorA.g,
            oldMetadata.metadata.colorA.b,
          ).toHexString(),
        );
      }

      // console.log('Color hex : ', hexColors)
      if (hexColors.length > 0) applyColorArray(newMesh, hexColors);

      newMesh.freezeWorldMatrix();
    }
  });
}

function updateTileRotation(mesh) {
  if (!mesh.metadata.print) return;
  let target = "yPrintTex";
  if (mesh.metadata.print.egoFileURL || mesh.metadata.print.egoImageFullURL) {
    target = "yCustomPrintTex";
  }
  const textureBlock = mesh.material
    .getTextureBlocks()
    .find((block) => block.name === target);
  textureBlock.texture.wAng = mesh.metadata.print.rotation || 0;
}

function copyStyle(targetMesh, sourceMesh, includeMat = true) {
  if (targetMesh !== sourceMesh) {
    let possibleMaterialObj = targetMesh.metadata.material;

    RH.ResetMesh(targetMesh, true);
    if (RH.SurfaceApplied(sourceMesh)) {
      const targetSurfaceType = RH.GetSurfaceType(targetMesh);
      if (sourceMesh.metadata.material && includeMat) {
        if (
          (targetSurfaceType !== RH.GetSurfaceType(sourceMesh) &&
            !possibleMaterialObj) ||
          possibleMaterialObj?.id != sourceMesh.metadata.material.id
        ) {
          // let materialToApply = sourceMesh.metadata.material;
          // if(sourceMesh.name.startsWith('accent'))
          // {
          //   unsetMaterial(sourceMesh)
          // }
          applyMaterialOnSameSurfaces(targetMesh, sourceMesh.metadata.material);
        } else {
          applyMaterial(targetMesh, sourceMesh.metadata.material);
        }
      }
      if (targetSurfaceType !== 2 && sourceMesh.metadata.print) {
        applyPrint(targetMesh, sourceMesh.metadata.print);

        const inputBlock = targetMesh.material.getBlockByName("useCustomPrint");
        if (inputBlock && inputBlock.value == 1) {
          return;
        }
      }
      const hexColors = [];
      const colorProps = ["colorR", "colorG", "colorB", "colorA"];

      colorProps.forEach((prop) => {
        if (sourceMesh.metadata[prop]) {
          const block = sourceMesh.material.getBlockByName(prop);
          if (block && block.value) {
            hexColors.push(block.value.toHexString());
          }
        }
      });
      applyColorArray(targetMesh, hexColors);
    }
  }
}

function toggleCameraForFullscreen(applicationMode) {
  if (applicationMode) {
    camera.detachControl();
    camera.attachControl(null, null, true, 1);
  } else {
    camera.detachControl();
    camera.attachControl(null, null, false, false);
    camera.setTarget(new BABYLON.Vector3(0, 0, 0));
  }
}

export function Reset3DScene() {
  if (scene) {
    const meshes = [...scene.meshes];
    meshes.forEach((mesh) => {
      if (!mesh.name.startsWith("light") && !mesh.name.startsWith("camera")) {
        mesh.dispose();
      }
    });

    if (shadowGenerator) {
      shadowGenerator.dispose();
      shadowGenerator = null;
    }
  }

  patternProps = {
    currentTemplate: null,
    currentAccentID: null,
    currentFrameID: null,
    currentAccentScale: null,
    currentAccentNumber: null,
    currentAccentRotation: null,
    currentSceneID: null,
    // boarderWidth: 0,
    // boarderType: 'square',
    mattingWidth: 0,
    currentPrintTiling: 1,
  };

  previousAccentParents.forEach((p) => p.dispose());
  previousAccentParents = [];

  accentParentOffsets.clear();
  galleryFrameOriginalDimensions.clear();

  framePartMeshes = [];

  meshesSelectedForMerging.clear();
  currentMerges = {};

  initialAccentUVs = [];

  isTemplateLoading = false;
  isAccentLoading = false;
  isFrameLoading = false;
  isRestoring = false;
  isFirstScreenshotTaken = false;
  firstApplyPatternDone = false;
  outlineNeedsUpdate = false;

  sharedMaterial = null;
  sharedFrom = null;
  previousPickedMesh = null;

  templateMeshesCache = [];

  if (typeof RH !== "undefined" && RH.Reset) {
    RH.Reset();
  }

  console.log("✅ Scene is clean.");
}
